export const enUSmessage = {

    // Common word
    'add': 'Add',
    'remove': 'Remove',
    'error': 'Error',
    'success': 'Success',
    'notAvailable': 'N/A',
    'yes': 'Yes',
    'no': 'No!',
    'results': 'results',
    'next': 'Next',
    'previous': 'Previous',
    'unknown': "Unknown",
    'type': "Type",
    'site': "Site",
    'featured': "Featured",
    'totalPossiblePoints': "Total Possible Points",
    'analytics': "Analytics",
    'modified': "Modified",
    'noResults': 'No results found',
    'received': 'Received',
    'sent': 'Sent',
    'cancel': 'Cancel',
    'clear': 'Clear',
    'confirm': 'Confirm',

    // Generic Buttons
    'buttons.publish': 'Publish',
    'buttons.unpublish': 'Unpublish',
    'buttons.publishNow': 'Publish now',
    'buttons.publishAll': 'Publish all',
    'buttons.validate': 'Validate',
    'buttons.validateAll': 'Validate all',
    'buttons.save' : 'Save',
    'buttons.saveAsNew' : 'Save as New',
    'buttons.saveOver': 'Save over existing',
    'buttons.preview': 'Preview',
    'buttons.viewAll': 'View All',
    'buttons.viewAllPlatforms': 'View All Platforms',
    'buttons.hideAll': 'Hide All',
    'buttons.copy': 'Copy',
    'buttons.archive': 'Archive',
    'buttons.delete': 'Delete',
    'buttons.select': 'Select',
    'buttons.upload': 'Upload',
    'buttons.view_submissions': 'View Submissions',
    'buttons.view_pending_submissions': "View Pending Submissions",

    'buttons.image.enter.id': "Enter ID",

    //Login/User
    'login.forgetPasswordSuccess' : 'Check your email :)',

    // Redirect messaging
    'redirect.noAccess': 'You do not have access to the page you requested. You will be redirected in {seconds} seconds.',

    // Resource Types
    'resource.types.ArticleStep': "Article Step",
    'resource.types.MenuContent': "Menu",
    'resource.types.MenuContentItem': "Menu Item",
    'resource.types.ArticleBlockQuote': "Article Block Quote",
    'resource.types.ArticleBodyCopy': "Article Body Copy",
    'resource.types.ArticleEmbedContent': "Article Embed Content",
    'resource.types.ArticleImage': "Article Image",
    'resource.types.ArticleImageComparison': "Article Image Comparison",
    'resource.types.ArticleSubhead': "Article Subhead",
    'resource.types.ChecklistItemGroup': "Checklist Item Group",
    'resource.types.CustomHtmlStep': "Custom Html Step",
    'resource.types.CompleteStep': "Complete Step",
    'resource.types.DragAndDropStep': "Drag and Drop Step",
    'resource.types.DailybreakJob': "Dailybreak Job",
    'resource.types.Image': "Image",
    'resource.types.OriginalImage': "Original Image",
    'resource.types.Filter': "Filter",
    'resource.types.Break': "Break",
    'resource.types.Category': "Category",
    'resource.types.Prize': "Prize",
    'resource.types.Challenge': "Challenge",
    'resource.types.ChecklistStep': "Checklist Step",
    'resource.types.ChecklistResult': "Checklist Result",
    'resource.types.BreakStep': "Step",
    'resource.types.LeadGen': "LeadGen",
    'resource.types.LeadGenField': "LeadGen Field",
    'resource.types.FilteringStep': "Filtering Step",
    'resource.types.GroceryStep': "Grocery List Step",
    'resource.types.Listicle': "Listicle",
    'resource.types.ListicleStep': "Listicle Step",
    'resource.types.ListicleBlockQuote': "Listicle Block Quote",
    'resource.types.ListicleBodyCopy': "Listicle Body Copy",
    'resource.types.ListicleEmbedContent': "Listicle Embed Content",
    'resource.types.ListicleImage': "Listicle Image",
    'resource.types.ListicleImageComparison': "Listicle Image Comparison",
    'resource.types.ListicleItem': "Listicle Item",
    'resource.types.ListicleOldBodyCopy': "Listicle Old Body Copy",
    'resource.types.ListicleSubhead': "Listicle Subhead",
    'resource.types.MemoryMatchGame': "Memory Match Game",
    'resource.types.MemoryMatchCard': "Memory Match Card",
    'resource.types.OverlayImage': "Overlay Image",
    'resource.types.PersonalityQuizAnswer': "Personality Quiz Answer",
    'resource.types.PersonalityQuizResult': "Personality Quiz Result",
    'resource.types.PersonalityQuizQuestion': "Personality Quiz Question",
    'resource.types.Poll': "Poll",
    'resource.types.PollQuestion': "Poll Question",
    'resource.types.PollAnswer': "Poll Answer",
    'resource.types.ReceiptCampaignDetailedInstruction': 'Requirement Item',
    'resource.types.ReceiptCampaignReminderInstruction': 'Reminder',
    'resource.types.ReceiptCampaignStepInstruction': "Receipt Campaign Step Instruction",
    'resource.types.ReferralStep': "Referral Step",
    'resource.types.ReferralLink': "Referral Link",
    'resource.types.SpotTheDifferenceDifference': "Spot The Difference Difference",
    'resource.types.StepInstruction': "Step Instruction",
    'resource.types.StoreFinderStep': "Store Finder Step",
    'resource.types.StoreLocationFile': "Store Location File",
    'resource.types.TriviaQuestion': "Text Trivia Question",
    'resource.types.TriviaAnswer': "Text Trivia Answer",
    'resource.types.TextTriviaResult': "Text Trivia Result",
    'resource.types.Palette': "Palette",
    'resource.types.UGCCampaignInstruction': "UGC Campaign Instruction",
    'resource.types.UGCImageLayer': "UGC Image Layer",
    'resource.types.User': "User",
    'resource.types.VideoStep': "Video Step",
    'resource.types.LeadGenStep': "Lead Gen Step",
    'resource.types.MemoryMatchStep': "Memory Match Step",
    'resource.types.PersonalityQuizStep': "Personality Quiz Step",
    'resource.types.PinterestStep': "Pinterest Step",
    'resource.types.PollStep': "Poll Step",
    'resource.types.ReceiptVerificationStep': "Receipt Verification Step",
    'resource.types.SpotTheDifferenceStep': "Spot the Difference Step",
    'resource.types.TextTriviaStep': "Text Trivia Step",
    'resource.types.PhotoStep': "UGC Step",

    'resource.types.Group.name.admin': 'Admin',
    'resource.types.Group.name.root': 'Root',
    'resource.types.Group.name.content_manager': 'Content Manager',
    'resource.types.Group.name.interns': 'Interns',
    'resource.types.Group.name.restricted admin': 'Restricted Admin',
    'resource.types.Group.name.cproot': 'CP Strategy Root Users',
    'resource.types.Group.name.cp_strategy': 'CP Strategy',
    'resource.types.Group.name.cp_strategy_admin': 'CP Strategy Admin Users',
    'resource.types.Group.name.none': 'No Access',
    'resource.types.Group.name.None': 'No Access',

    // Create buttons
    'create.button.articleblockquote': 'Block Quote',
    'create.button.menucontent': 'Menu',
    'create.button.menucontentitem': 'Menu Item',
    'create.button.articlebodycopy': 'Body Copy',
    'create.button.articleembedcontent': 'Embed',
    'create.button.articlelinkbutton': 'Button',
    'create.button.articleoldbodycopy': 'Old Body Copy',
    'create.button.articleimage': 'Image',
    'create.button.articleimagecomparison': 'Image Comparison',
    'create.button.articlesubhead': 'Subhead',
    'create.button.checklistitemgroup': 'List Item',
    'create.button.checklistresult': 'Result',
    'create.button.filteringdropdown': 'Dropdown',
    'create.button.filteringdropdownitem': 'Dropdown Item',
    'create.button.filteringresult': 'Result',
    'create.button.filteringresultblockquote': 'Block Quote',
    'create.button.filteringresultbodycopy': 'Body Copy',
    'create.button.filteringresultembed': 'Embed',
    'create.button.filteringresultimage': 'Image',
    'create.button.filteringresultlinkbutton': 'Button',
    'create.button.grocerychecklist': 'Checklist',
    'create.button.grocerychecklistitem': 'Checklist Item',
    'create.button.grocerychecklistresultlink': 'Result Link',
    'create.button.leadgenconfirmation': 'Confirmation',
    'create.button.leadgenfield': 'Form Field',
    'create.button.listicleaddtocalendar': 'Add To Calendar',
    'create.button.listicleblockquote': 'Block Quote',
    'create.button.listiclebodycopy': 'Body Copy',
    'create.button.listicleembedcontent': 'Embed',
    'create.button.listiclelinkbutton': 'Button',
    'create.button.listicleoldbodycopy': 'Old Body Copy',
    'create.button.listicleimage': 'Image',
    'create.button.listicleimagecomparison': 'Image Comparison',
    'create.button.listicleitem': 'List item',
    'create.button.overlayimage': 'Item',
    'create.button.personalityquizanswer': 'Answer',
    'create.button.personalityquizresult': 'Result',
    'create.button.personalityquizquestion': 'Question',
    'create.button.pollquestion': 'Question',
    'create.button.pollanswer':   'Answer',
    'create.button.mediauploadconfirmation': 'Confirmation Checkbox',
    'create.button.receiptcampaignstepinstruction': 'Instruction',
    'create.button.receiptcampaigndetailedinstruction': 'Requirement Item',
    'create.button.receiptcampaignreminderinstruction': 'Reminder Instruction',
    'create.button.referrallink': 'Referral',
    'create.button.relatedbreak': 'Related Link',
    'create.button.spotthedifferencelevel': 'Scene',
    'create.button.spotthedifferenceinstruction': 'Instruction',
    'create.button.stepinstruction': 'Instruction',
    'create.button.texttriviaanswer': 'Answer',
    'create.button.texttriviaresult': 'Result',
    'create.button.texttriviaquestion': 'Question',
    'create.button.triviaquestion': 'Question',
    'create.button.triviaanswer':   'Answer',
    'create.button.ugccampaigninstruction': 'Instruction',
    'create.button.ugcimagelayer': 'Frame',
    'create.button.actiontaglink': 'User Tag',
    'create.button.keyvaluepair': 'Key/Value Pair',

    // Delete buttons
    'delete.button.articleblockquote': 'Block Quote',
    'delete.button.menucontent': 'Menu',
    'delete.button.menucontentitem': 'Menu Item',
    'delete.button.articlebodycopy': 'Body Copy',
    'delete.button.articleembedcontent': 'Embed',
    'delete.button.articleoldbodycopy': 'Old Body Copy',
    'delete.button.articleimage': 'Image',
    'delete.button.articleimagecomparison': 'Image Comparison',
    'delete.button.articlelinkbutton': 'Button',
    'delete.button.articlesubhead': 'Subhead',
    'delete.button.checklistitemgroup': 'List Item',
    'delete.button.checklistresult': 'Result',
    'delete.button.filteringdropdown': 'Dropdown',
    'delete.button.filteringdropdownitem': 'Dropdown Item',
    'delete.button.filteringresult': 'Result',
    'delete.button.filteringresultbodycopy': 'Body Copy',
    'delete.button.filteringresultblockquote': 'Block Quote',
    'delete.button.filteringresultembed': 'Embed',
    'delete.button.filteringresultimage': 'Image',
    'delete.button.filteringresultlinkbutton': 'Button',
    'delete.button.leadgenfield': 'Form Field',
    'delete.button.leadgenconfirmation': 'Confirmation',
    'delete.button.listicleaddtocalendar': 'Add To Calendar',
    'delete.button.listicleblockquote': 'Block Quote',
    'delete.button.listiclebodycopy': 'Body Copy',
    'delete.button.listicleembedcontent': 'Embed',
    'delete.button.listicleimage': 'Image',
    'delete.button.listicleimagecomparison': 'Image Comparison',
    'delete.button.listicleitem': 'List item',
    'delete.button.listiclelinkbutton': 'Button',
    'delete.button.listicleoldbodycopy': 'Old Body Copy',
    'delete.button.overlayimage': 'Item',
    'delete.button.personalityquizanswer': 'Answer',
    'delete.button.personalityquizresult': 'Result',
    'delete.button.personalityquizquestion': 'Question',
    'delete.button.pollquestion': 'Question',
    'delete.button.pollanswer':   'Answer',
    'delete.button.referrallink': 'Referral',
    'delete.button.receiptcampaigndetailedinstruction': 'Requirement Item',
    'delete.button.receiptcampaignreminderinstruction': 'Reminder Instruction',
    'delete.button.receiptcampaignstepinstruction': 'Instruction',
    'delete.button.relatedbreak': 'Related Link',
    'delete.button.spotthedifferencelevel': 'Scene',
    'delete.button.spotthedifferenceinstruction': 'Instruction',
    'delete.button.stepinstruction': 'Instruction',
    'delete.button.texttriviaanswer': 'Answer',
    'delete.button.texttriviaresult': 'Result',
    'delete.button.texttriviaquestion': 'Question',
    'delete.button.triviaquestion': 'Question',
    'delete.button.triviaanswer':   'Answer',
    'delete.button.ugccampaigninstruction': 'Instruction',
    'delete.button.ugcimagelayer': 'Frame',
    'delete.button.actiontaglink': 'User Tag',

    'color.white': "White",
    'color.black': "Black",

    'font.amatic': 'Amatic',
    'font.arial': 'Arial',
    'font.boogaloo': 'Boogaloo',
    'font.helvetica': 'Helvetica',
    'font.impact': 'Impact',
    'font.lato': 'Lato',
    'font.roboto': 'Roboto',
    'font.times_new_roman': 'Times New Roman',

    'modal.confirmCancel.bulkUpload.header': 'Confirm cancel bulk image uploading',
    'modal.confirmCancel.bulkUpload.message': 'Are you sure you want to stop uploading?<br/><br/>You will lose any unsaved work, but the images that you have already uploaded will remain intact.',

    // Visible Columns modal
    'modal.visibleColumns.header': 'Show/Hide Columns',
    'modal.visibleColumns.cancel': 'Cancel',
    'modal.visibleColumns.confirm': 'Confirm',

    'modal.verify.unpublish.header': "Unpublish Challenge",
    'modal.verify.unpublish.content': "Are you sure you want to unpublish: ",

    // Winner contact/history modal
    'modal.winnerDetail.button.contact': 'Contact',
    'modal.winnerDetail.button.prizeHistory': 'Prize History',
    'modal.winnerDetail.label.address': 'Address',
    'modal.winnerDetail.label.email': 'Email',
    'modal.winnerDetail.label.phone': 'Phone',
    'modal.winnerDetail.label.prize': 'Prize',
    'modal.winnerDetail.label.winDate': 'Win Date',
    'modal.winnerDetail.label.forfeitDate': 'Forfeit Date',

    // Delete modal fields
    'modal.delete.header': 'Please Confirm Delete.',
    'modal.undelete.header': 'Please Confirm Un-delete.',
    'modal.delete.confirm': 'Delete',
    'modal.undelete.confirm': 'Un-delete',
    'modal.delete.cancel': 'Do Not Delete',
    'modal.undelete.cancel': 'Do Not Un-delete',

    'modal.delete.break.permalink': 'Deleting Break with URL: {permalink}',

    'modal.delete.user.header': 'Please Confirm Deactivate User.',
    'modal.delete.user.cancel': 'Do Not Deactivate',
    'modal.delete.user.confirm': 'Deactivate User',
    'modal.undelete.user.header': 'Please Confirm Reactivate User.',
    'modal.undelete.user.cancel': 'Do Not Reactivate',
    'modal.undelete.user.confirm': 'Reactivate User',

    'modal.delete.user.email': 'Are you sure you want to deactivate user {email}?',
    'modal.undelete.user.email': 'Are you sure you want to reactivate user {email}?',

    // Date Range filter
    'dateRange.button': 'Date Range',
    'dateRange.modal.header': 'Filter by Date Range',
    'dateRange.modal.label.filterType': 'Filter Type',
    'dateRange.modal.label.lowerBound': 'Lower Bound',
    'dateRange.modal.label.upperBound': 'Upper Bound',

    'dateRange.filterType.LiveRange': 'By Live Range',
    'dateRange.filterType.EndDate': 'By End Date',

    // General Break Information Accordion
    'editbreak.general.heading': 'General Break Information',
    'editbreak.section.navandfilters.heading': 'Break Site Filters',
    'editbreak.section.design.heading': 'Break Page/Site Assets',
    'editbreak.section.prizing.heading': 'Break Prizing / T&C',
    'editbreak.section.steps.heading': 'Break Step Management',
    'editbreak.section.images.heading': 'Break Image Upload',
    'editbreak.section.account.heading': 'Account Information',
    'editbreak.section.targeting.heading': 'Break Campaign Targeting',
    'editbreak.section.color.heading': 'Break Color Assignments',

    'editbreak.general.description': 'Description',
    'editbreak.general.breakTags': "Break Tags",
    'editbreak.general.title': 'Break Title',
    'editbreak.general.title.placeholder': 'Enter title for break',
    'editbreak.general.page_title': 'SEO Title Tag',
    'editbreak.general.page_title.placeholder': 'Enter SEO title for break',
    'editbreak.general.meta_description': 'Break Meta Description',
    'editbreak.general.social_description': 'Social Description',
    'editbreak.general.step.headline': 'Step Headline',
    'editbreak.general.step.headline.placeholder': 'Enter headline for step',
    'editbreak.general.url': 'Break permalink (or slug)',
    'editbreak.general.schedule_start_date': 'Set Publish Date & Time?',
    'editbreak.general.date.publish': 'Select Date & Time',
    'editbreak.general.date.publish.placeholder': 'Publish Date & Time',
    'editbreak.general.archive_break': 'Set Archive Date & Time?',
    'editbreak.general.date.archive': 'Select Date & Time',
    'editbreak.general.archive.placeholder': 'Archive Date & Time',
    'editbreak.general.stepSocialShareDefaultOn': 'Default Social Sharing On?',
    'editbreak.general.authorIds': 'Author Name',
    'editbreak.general.date.placeholder': 'Select Date',
    'editbreak.general.sponsorName': 'Sponsor Name',
    'editbreak.general.sponsorName.placeholder': 'Enter Sponsor Name',
    'editbreak.general.editPageHeadline': 'Edit the Landing Page Headline and Intro Copy?',
    'editbreak.general.editPageMobileHeadline': 'Edit the Mobile Landing Page Headline and Intro Copy?',
    'editbreak.general.facebookComments': 'Show Facebook Comments?',
    'editbreak.general.pointAward': 'Point Award',

    'editbreak.general.mapPage.headline': 'Landing Page Headline',
    'editbreak.general.mapPage.mobileHeadline': 'Landing Page Headline Mobile',
    'editbreak.general.mapPage.description': 'Landing Page Intro Copy',
    'editbreak.general.mapPage.mobileDescription': 'Landing Page Intro Copy Mobile',

    'editbreak.general.map_headline_type' : 'Landing Page Headline Type',
    'editbreak.general.map_headline_type.text' : 'Text',
    'editbreak.general.map_headline_type.image' : 'Image',
    'editbreak.general.mapPage.headline_image' : 'Landing Page Image Headline',
    'editbreak.general.mapPage.mobile_headline_image' : 'Mobile Landing Page Image Headline',

    'editbreak.general.mobile_map_headline_type' : 'Mobile Landing Page Headline Type',
    'editbreak.general.mobile_map_headline_type.text' : 'Text',
    'editbreak.general.mobile_map_headline_type.image' : 'Image',

    'editbreak.general.exclusive': 'Exclusive Content?',

    'editbreak.general.layout': 'Break Layout',
    'editbreak.general.layout.classic_2018': 'Classic (2018)',
    'editbreak.general.layout.vertical_scroll': 'Vertical Scroll',

    'editbreak.account_info.has_guaranteed_engagements': 'Has Total Guaranteed Engagements',
    'editbreak.account_info.guaranteed_engagements': 'Total Guaranteed Engagements',
    'editbreak.account_info.has_cost_per_engagement': 'Has Cost per Engagement',
    'editbreak.account_info.cost_per_engagement': 'Cost per Engagement',
    'editbreak.account_info.currency': 'Currency',
    'editbreak.account_info.currency.gbp': 'GBP',
    'editbreak.account_info.currency.usd': 'USD',

    'editbreak.account_info.ngc_api': 'Select NGC API',
    'editbreak.account_info.ngc_delivery_type': 'NGC Delivery Type',


    'editbreak.design.backgroundImageId': 'Background Image',
    'editbreak.design.landingBackgroundImage': 'Landing Background Image',
    'editbreak.design.landingBackgroundOverlay': 'Include Background Overlay',

    'editbreak.design.backgroundTileImageId': 'Background Tile Image',
    'editbreak.design.sponsoredLogoId': 'Client Logo',
    'editbreak.design.report_header_image': 'Report Header',
    'editbreak.design.mobileSponsoredLogoId': 'Mobile Client Logo',
    'editbreak.design.mobileMapHeaderImageId': 'Mobile Break Header Image',
    'editbreak.design.cardImageId': 'Classic Home Page Trending Image',
    'editbreak.design.heroImageId': 'Classic Hero Card Image',
    'editbreak.design.featuredImageId': 'Classic Home Page Featured Image',

    // 2020 homepage layout
    'editbreak.design.heroCard': 'Hero Card Image',
    'editbreak.design.tileImage': 'Tile Image',
    'editbreak.design.headerImage': 'Header Background Image',


    'editbreak.design.socialShareBadgeId': 'Facebook Image',
    'editbreak.design.pinterestShareImageId': 'Pinterest Image',
    'editbreak.design.footerHtml': 'HTML Footer on All Break Pages',
    'editbreak.design.mobileFooterHtml': 'Mobile HTML Footer on All Break Pages',
    'editbreak.design.landingPageFooterHtml': 'HTML Footer on Landing Page',
    'editbreak.design.generateDesignImages': 'Generate Trending, Featured and Facebook Images',
    'editbreak.design.generate': 'Generate',
    'editbreak.design.generateAndUpload': 'Generate & Upload',

    'editbreak.design.introImageId': 'Intro Image',
    'editbreak.design.leftIntroImage': 'Left Intro Image',
    'editbreak.design.introHeaderImage': 'Intro Header Image',
    'editbreak.design.logoImage': 'Client Logo (upper right)',
    'editbreak.design.rightIntroImage': 'Right Intro Image',
    'editbreak.design.defaultStepBackgroundImageId': 'Default Step Background Image',

    'editbreak.colors.themeColor1': 'Background',
    'editbreak.colors.themeColor2': 'Copy',
    'editbreak.colors.themeColor3': 'Primary Color (buttons)',    // primary == buttons
    'editbreak.colors.themeColor4': 'Primary Copy Color',
    'editbreak.colors.themeColor5': 'Secondary Color (accents)',    // primary == buttons
    'editbreak.colors.themeColor6': 'Secondary Copy Color',

    'editbreak.colors.colorPalette' : 'Select palette',
    'editbreak.colors.paletteNoName' : 'Color Palette',
    'editbreak.colors.paletteCustom' : 'Custom Palette',
    'editbreak.colors.savePaletteHeader': 'Would you like to save this palette?',
    'editbreak.colors.paletteInputLabel' : 'Name this palette',
    'editbreak.colors.paletteInputPlaceHolder': 'Enter a new palette name',
    'editbreak.colors.savePalette' : 'Save Palette',
    'editbreak.colors.savePaletteSuccess' : 'New palette created!',
    'editbreak.colors.pageBg': 'Page bkgd color',
    'editbreak.colors.replayText': '"Replay" Text Color',
    'editbreak.colors.resultPageTextBg': 'Result page (text bbkgd) color',
    'editbreak.colors.buttonColor': 'Button color',
    'editbreak.colors.lockedOverlayColor': 'Locked overlay color',
    'editbreak.colors.brandThemeColor': 'Brand theme color',
    'editbreak.colors.brandThemeText': 'Brand theme text',
    'editbreak.colors.termsColor': 'Legal/T&C text color',
    'editbreak.colors.progressBarMainBg': 'Progress bar main bkgd color',
    'editbreak.colors.progressBarText': 'Progress bar text color',
    'editbreak.colors.progressBarSuccessBg': 'Progress bar success bkgd color',
    'editbreak.colors.progressBarFailBg': 'Progress bar fail bkgs color',
    'editbreak.colors.landing_page_headline_color': 'Landing Page Headline Color',
    'editbreak.colors.mobile_landing_page_headline_color': 'Mobile Landing Page Headline Color',
    'editbreak.colors.landing_page_intro_color': 'Landing Page Intro Color',
    'editbreak.colors.mobile_landing_page_intro_color': 'Mobile Landing Page Intro Color',
    'editbreak.colors.sponsorName': 'Sponsor name color',
    'editbreak.colors.website_copy_color': 'Website Copy Color',
    'editbreak.colors.mobile_website_copy_color': 'Mobile Website Copy Color',
    'editbreak.colors.useNavAndFooterColor': 'Custom Nav and Footer Color',
    'editbreak.colors.navAndFooterBackgroundColor': 'Nav and Footer Background Color',
    'editbreak.colors.navAndFooterFontColor': 'Nav and Footer Font Color',
    'editbreak.colors.navAndFooterImageColor': 'Nav and Footer Image Color',
    'editbreak.colors.customCss': 'Custom CSS',

    'editbreak.general.learnMoreSectionHeadline': '"Learn More" Modal After Main Break Page Intro Copy?',
    'editbreak.general.learnMoreHeadline': 'Modal headline',
    'editbreak.general.learnMoreDesc': 'Modal body copy',
    'editbreak.general.learnMoreButtonCopy': 'Modal button copy',
    'editbreak.general.learnMoreImageId': 'Learn more modal image',
    'editbreak.general.has_map_tracking': 'Landing Page Pixel Tracking?',
    'editbreak.general.has_home_page_tracking': 'Landing Home Page Pixel Tracking?',
    'editbreak.general.break_pixel_tracking': "Break Pixel Tracking",
    'editbreak.general.break_home_page_pixel_tracking': "Break Home Page Pixel Tracking",

    "editbreak.breaksNavFilters.requiresCategoryFilter": "Limit To Category (Not on Homepage)?",
    "editbreak.breaksNavFilters.hideOnHomepage": "View Only as Direct URL (Not on any Sites)?",
    "editbreak.breaksNavFilters.blockGuestAccess": "Block Guest Access?",

    "editbreak.breaksNavFilters.dbcat_entertainment": "Entertainment:",
    "editbreak.breaksNavFilters.dbcat_lifestyle": "Lifestyle:",
    "editbreak.breaksNavFilters.dbcat_laugh": "Laugh:",
    "editbreak.breaksNavFilters.dbcat_news": "News:",
    "editbreak.breaksNavFilters.dbcat_family": "Family:",

    "editbreak.breaksNavFilters.dbcat_breakfast": "Breakfast",
    "editbreak.breaksNavFilters.dbsubcat_breakfast_breakfast": " ",
 
    "editbreak.breaksNavFilters.dbcat_soupsandsalads": "Soups Salads",
    "editbreak.breaksNavFilters.dbsubcat_soupsandsalads_soupsandsalads": " ",

    "editbreak.breaksNavFilters.dbcat_healthy": "Healthy",
    "editbreak.breaksNavFilters.dbsubcat_healthy_healthy": " ",

    "editbreak.breaksNavFilters.dbcat_mains": "Mains",
    "editbreak.breaksNavFilters.dbsubcat_mains_mains": " ",


    "editbreak.breaksNavFilters.dbcat_snacks": "Snacks",
    "editbreak.breaksNavFilters.dbsubcat_snacks_snacks": " ",


    "editbreak.breaksNavFilters.dbcat_drinks": "Drinks",
    "editbreak.breaksNavFilters.dbsubcat_drinks_drinks": " ",


    "editbreak.breaksNavFilters.dbcat_desserts": "Desserts",
    "editbreak.breaksNavFilters.dbsubcat_desserts_desserts": " ",



    "editbreak.breaksNavFilters.dbsubcat_entertainment_celebs": "Celebs",
    "editbreak.breaksNavFilters.dbsubcat_entertainment_books": "Books",
    "editbreak.breaksNavFilters.dbsubcat_entertainment_movies": "Movies",
    "editbreak.breaksNavFilters.dbsubcat_entertainment_music": "Music",
    "editbreak.breaksNavFilters.dbsubcat_entertainment_tv": "Television",
    "editbreak.breaksNavFilters.dbsubcat_entertainment_sports": "Sports",

    "editbreak.breaksNavFilters.dbsubcat_lifestyle_decor": "Decor",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_beauty": "Beauty",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_parents": "Parents",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_style": "Style",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_food": "Food",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_pets": "Pets",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_health": "Health & Wellness",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_wedding": "Wedding",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_family": "Friends & Family",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_fitness": "Fitness",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_friends": "Friends",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_relationship": "Relationship",
    "editbreak.breaksNavFilters.dbsubcat_lifestyle_travel": "Travel",

    "editbreak.breaksNavFilters.dbsubcat_laugh_geeky": "Geeky",
    "editbreak.breaksNavFilters.dbsubcat_laugh_people": "People",
    "editbreak.breaksNavFilters.dbsubcat_laugh_animals": "Animals",
    "editbreak.breaksNavFilters.dbsubcat_laugh_viral": "Viral",
    "editbreak.breaksNavFilters.dbsubcat_laugh_local": "Local",

    "editbreak.breaksNavFilters.dbsubcat_news_politics": "Politics",
    "editbreak.breaksNavFilters.dbsubcat_news_business": "Business",
    "editbreak.breaksNavFilters.dbsubcat_news_technology": "Technology",
    "editbreak.breaksNavFilters.dbsubcat_news_controversial": "Controversial",
    "editbreak.breaksNavFilters.dbsubcat_news_world": "World",
    "editbreak.breaksNavFilters.dbsubcat_news_sports": "Sports",

    "editbreak.breaksNavFilters.dbsubcat_family_formoms": "For Moms",
    "editbreak.breaksNavFilters.dbsubcat_family_laugh": "Laugh",
    "editbreak.breaksNavFilters.dbsubcat_family_education": "Education",
    "editbreak.breaksNavFilters.dbsubcat_family_technology": "Technology",
    "editbreak.breaksNavFilters.dbsubcat_family_inspire": "Inspire",
    "editbreak.breaksNavFilters.dbsubcat_family_food": "Food",
    "editbreak.breaksNavFilters.dbsubcat_family_entertainment": "Entertainment",

    "editbreak.breaksPrizingInformation.prizingTiedStep": "Choose Step Controlling Sweepstakes",
    "editbreak.breaksPrizingInformation.sweepstakesDateTime": "Sweepstakes Date & Time",
    "editbreak.breaksPrizingInformation.sweepstakesStartDate": "Set Start Date?",
    "editbreak.breaksPrizingInformation.sweepstakesEndDate": "Set End Date?",
    "editbreak.breaksPrizingInformation.grandPrizeId": "Grand Prize",
    "editbreak.breaksPrizingInformation.runnerupPrizeId": "Runner Up Prize",
    "editbreak.breaksPrizingInformation.weeklyPrizeId": "Weekly Prize",
    "editbreak.breaksPrizingInformation.weeklyPrizeAwardDates": "Add Weekly Prize Award Date to Legal?",
    "editbreak.breaksPrizingInformation.numberOfPrizes": "Number of Prizes",
    "editbreak.breaksPrizingInformation.approximateRetailValueOfPrizes": "Approximate Value of All Prizes",
    "editbreak.breaksPrizingInformation.addSponsorToLegal": "Add Sponsor to Legal",
    "editbreak.breaksPrizingInformation.useCustomAbbreviatedTerms": "Use Custom Abbreviated Terms and Conditions?",
    "editbreak.breaksPrizingInformation.customAbbreviatedTerms": "Custom Abbreviated Terms and Conditions",
    "editbreak.breaksPrizingInformation.addTermsAndConditions": "Add Additional Terms and Conditions?",
    "editbreak.breaksPrizingInformation.termsAndConditions": "Additional Terms and Conditions",
    "editbreak.breaksPrizingInformation.addFullOfficialRules": "Add Full Official Rules?",
    "editbreak.breaksPrizingInformation.fullOfficialRules": "Full Official Rules",

    'editbreak.image_upload.header': 'Upload and store all the original images that will be used in a break. Images can always be uploaded later, or at the individual step level.',
    'editbreak.image_upload.file_types_allowed': 'File types allowed are: JPG, JPEG, GIF & PNG.',
    'editbreak.image_upload.continue': 'Continue',

    'editbreak.targeting.segments': "Segments",
    'editbreak.targeting.genders': "Genders",
    'editbreak.targeting.genders.male': 'Male',
    'editbreak.targeting.genders.female': 'Female',
    'editbreak.targeting.genders.unspecified': 'Unspecified',
    'editbreak.targeting.states': 'States',
    'editbreak.targeting.targetZipCodes': "Target Zipcodes",
    'editbreak.targeting.excludedZipCodes': "Blocked Zipcodes",
    'editbreak.targeting.has_age_targeting': 'Apply Age Targeting?',
    'editbreak.targeting.age_target_min': "Age Target Minimum",
    'editbreak.targeting.age_target_max': "Age Target Maximum",
    'editbreak.targeting.has_age_gating': "Apply Age Gating?",
    'editbreak.targeting.age_gate_min': "Age Gate Minimum",
    'editbreak.targeting.age_gate_max': "Age Gate Maximum",

    'editbreak.steps.backgroundImage': "Background Image",
    'editbreak.steps.backgroundColor': "Background Color",
    'editbreak.steps.related_breaks.headline': 'Related Links',
    'editbreak.steps.related_breaks.header': 'Related Link',
    'editbreak.steps.related_breaks.relatedBreak': 'Related Break Title',
    'editbreak.steps.related_breaks.relatedBreakLink': 'Related Break Url Name',
    'editbreak.steps.related_breaks.commentQuestion': 'Facebook Comment Question',
    'editbreak.steps.related_breaks.reorder_toggle': 'Reorder related links',
    'editbreak.steps.nextButton.headline': 'Next/Skip Button',
    'editbreak.steps.nextButton.showNextButton': 'Show Next Button (UI currently ignores this)',
    'editbreak.steps.nextButton.buttonText': 'Button Text (UI currently ignores this)',
    'editbreak.steps.nextButton.buttonText.placeholder': 'Next',
    'editbreak.steps.nextButton.linkType': 'Link Type',
    'editbreak.steps.next_button.has_next_delay': 'Has 3 Second Delay',
    'editbreak.steps.nextButton.linkType.button': 'Button',
    'editbreak.steps.nextButton.linkType.hyperlink': 'Hyperlink',
    'editbreak.steps.skipButton.showSkipButton': 'Show Skip Button',
    'editbreak.steps.skipButton.buttonText': 'Button Text (UI currently ignores this)',

    'editbreak.steps.next_button.footer_html': 'Additional HTML Footer',
    'editbreak.steps.sharing.headline': 'Sharing',
    'editbreak.steps.sharing.sharing_on': 'Sharing On?',
    'editbreak.steps.sharing.facebook': 'Facebook',
    'editbreak.steps.sharing.facebook_url': 'Facebook URL',
    'editbreak.steps.sharing.facebook_title': 'Facebook Title',
    'editbreak.steps.sharing.facebook_description': 'Facebook Description',
    'editbreak.steps.sharing.twitter': 'Twitter',
    'editbreak.steps.sharing.twitter_url': 'Twitter URL',
    'editbreak.steps.sharing.twitter_description': 'Twitter Description',
    'editbreak.steps.sharing.pinterest': 'Pinterest',
    'editbreak.steps.sharing.pinterest_description': 'Pinterest Title',
    'editbreak.steps.sharing.pinterest_url': 'Pinterest URL',
    'editbreak.steps.sharing.whatsapp': 'Whatsapp',
    'editbreak.steps.sharing.email': 'Email',
    'editbreak.steps.sharing.print': 'Print',
    'editbreak.steps.sharing.copy': 'Copy',
    'editbreak.steps.sharing.download': 'Download',
    'editbreak.steps.tracking.headline': 'Tracking',
    'editbreak.steps.tracking.page_load_tracking': 'Step Pixel Tracking?',
    'editbreak.steps.tracking.page_load_tracking.placeholder': 'Enter code',
    'editbreak.steps.tracking.next_button_tracking': 'Step Next Button Tracking?',
    'editbreak.steps.tracking.next_button_tracking.placeholder': 'Enter code',
    'editbreak.steps.landingPage.headline': 'Landing Page',

    'editbreak.steps.background': 'Step Background',
    'editbreak.steps.background.backgroundImageId': 'Step Background Image (2560 x 1600)',
    'editbreak.steps.background.backgroundColor': 'Step Background Color',
    'editbreak.steps.background.backgroundOverlay': 'Include Background Overlay',

    'editbreak.steps.startScreen.header': 'Start Screen',
    'editbreak.steps.startScreen.has': 'Has Start Screen',
    'editbreak.steps.startScreen.headline': 'Start Screen Headline',
    'editbreak.steps.startScreen.body': 'Start Screen Body',
    'editbreak.steps.startScreen.footer': 'Start Screen Footer',
    'editbreak.steps.startScreen.backgroundImage': 'Background Image',
    'editbreak.steps.startScreen.backgroundColor': 'Background Color',
    'editbreak.steps.startScreen.backgroundOverlay': 'Include Background Overlay',

    'editbreak.steps.pointsScreen.header': 'Points',

    'editbreak.steps.landingPage.publishStep': 'Publish Step?',
    'editbreak.steps.landingPage.hoverText': 'Step Hover Text',
    'editbreak.steps.landingPage.stepLabel': 'Step BasicLabel',
    'editbreak.steps.landingPage.reportStepLabel': 'Report Step BasicLabel',
    'editbreak.steps.landingPage.internalStepLabel': 'Internal BasicLabel',
    'editbreak.steps.landingPage.mobileStepLabel': 'Mobile Step BasicLabel',
    'editbreak.steps.landingPage.landingPageStepImage': 'Step Landing Page Image',
    'editbreak.steps.landingPage.required_step_completions': 'Required Step Completions',
    'editbreak.steps.decisionTree.headline': 'Decision Tree',

    // Step Management
    'editbreak.step_management.header': 'Add, delete and re-order multiple steps',
    'editbreak.step_management.subheader': 'Steps can also be added and deleted in the View All Platforms section',
    'editbreak.step_management.reorder': 'Reorder step types',

    // Article
    'editbreak.steps.article.heading': 'Step: Article',
    'editbreak.steps.article.heading.abv': 'Step: Article',
    'editbreak.steps.article.innerHeading': 'Article: ',
    'editbreak.steps.article.headline': 'Headline',
    'editbreak.steps.article.header_image': 'Header Image',
    'editbreak.steps.article.intro_copy': 'Title Subhead',
    'editbreak.steps.article.intro_copy.placeholder': 'Enter intro copy for article',
    'editbreak.steps.article.has_voting': 'Allow voting?',
    'editbreak.steps.article.has_voting_end_date': 'Set End Date for Voting?',
    'editbreak.steps.article.voting_end_date': 'Select Date and Time',
    'editbreak.steps.article.default_upvote_text': 'Upvote/Positive Button Text',
    'editbreak.steps.article.default_upvote_icon': 'Upvote/Positive Button Icon',
    'editbreak.steps.article.default_downvote_text': 'Downvote/Negative Button Text',
    'editbreak.steps.article.default_downvote_icon': 'Downvote/Negative Button Icon',
    'editbreak.steps.article.has_vote_tracking': 'Add Tracking to Voting Buttons?',
    'editbreak.steps.article.upvote_tags': 'Upvote/Positive Button Tracking',
    'editbreak.steps.article.downvote_tags': 'Downvote/Negative Button Tracking',
    'editbreak.steps.article.block_quote.value': 'Block Quote',
    'editbreak.steps.article.block_quote.value.placeholder': 'Enter block quote',
    'editbreak.steps.article.block_quote_source.value': 'Block Quote Source',
    'editbreak.steps.article.block_quote_source.value.placeholder': 'Enter blockquote source',
    'editbreak.steps.article.old_body_copy.value': 'List item old body copy',
    'editbreak.steps.article.old_body_copy.value.placeholder': 'Enter listicle old body copy',
    'editbreak.steps.article.body_copy.value': 'List item body copy',
    'editbreak.steps.article.body_copy.value.placeholder': 'Enter listicle body',
    'editbreak.steps.article.image.type': 'List item image style',
    'editbreak.steps.article.image.type.custom': 'Custom',
    'editbreak.steps.article.image.type.horizontal': 'Horizontal',
    'editbreak.steps.article.image.type.vertical': 'Vertical',
    'editbreak.steps.article.image.image': 'Select image from break',
    'editbreak.steps.article.image.scaling': 'Scale image to % of step width?',
    'editbreak.steps.article.image.scaling.none': 'No scaling',
    'editbreak.steps.article.image.scaling.65': '65%',
    'editbreak.steps.article.image.scaling.75': '75%',
    'editbreak.steps.article.image_comparison.left_image': 'Left Image',
    'editbreak.steps.article.image_comparison.right_image': 'Right Image',
    'editbreak.steps.article.image_comparison.start_position': 'Initial Slider Position',
    'editbreak.steps.article.image_comparison.start_position.left': 'Left',
    'editbreak.steps.article.image_comparison.start_position.center': 'Center',
    'editbreak.steps.article.image_comparison.start_position.right': 'Right',
    'editbreak.steps.article.embed_code.value': 'Embed Code',
    'editbreak.steps.article.embed_code.value.placeholder': 'Enter embed code',
    'editbreak.steps.article.button.text': 'Text',
    'editbreak.steps.article.button.url': 'URL',
    'editbreak.steps.article.button.text_color': 'Text Color',
    'editbreak.steps.article.button.bg_color': 'Bkgd Color',
    'editbreak.steps.article.button.force_download': 'Force Download',
    'editbreak.steps.article.subhead': 'Article Subhead {sectionIndex}',
    'editbreak.steps.article.menucontent.text': 'Menu Text {sectionIndex}',
    'editbreak.steps.article.menucontent.item.label': 'Label {sectionIndex}',
    'editbreak.steps.article.menucontent.item.link': 'Link {sectionIndex}',
    'editbreak.steps.article.menucontent.item.trackingId': 'Tracking ID {sectionIndex}',
    'editbreak.steps.article.menucontent.item.image': 'Image {sectionIndex}',
    'editbreak.steps.article.content.reorder_toggle': 'Reorder Content',


    // Beaker2
    'editbreak.steps.beaker2.step_id': 'Step ID (Beaker2)',
    'editbreak.steps.beaker2.step_id.placeholder': 'Enter step ID',
    'editbreak.steps.beaker2.heading': 'Step: Beaker2',
    'editbreak.steps.beaker2.heading.abv': 'Step: Beaker2',
    'editbreak.steps.beaker2.innerHeading': 'Beaker2: ',
    'editbreak.steps.beaker2.headline': 'Headline',
    'editbreak.steps.beaker2.intro_copy': 'Title Subhead',
    'editbreak.steps.beaker2.intro_copy.placeholder': 'Enter intro copy for Beaker2',
    'editbreak.steps.beaker2.example_image': 'Example Image',

    // Checklist
    'editbreak.steps.checklist.heading': 'Step: Checklist',
    'editbreak.steps.checklist.heading.abv': 'Step: Checklist',
    'editbreak.steps.checklist.innerHeading': 'Checklist: ',
    'editbreak.steps.checklist.headline': 'Headline',
    'editbreak.steps.checklist.intro_copy': 'Title Subhead',
    'editbreak.steps.checklist.intro_copy.placeholder': 'Enter intro copy for Checklist',
    'editbreak.steps.checklist.body_copy': 'Body Copy',
    'editbreak.steps.checklist.body_copy.placeholder': 'Enter Body Copy',
    'editbreak.steps.checklist.header_image': 'Header Image',
    'editbreak.steps.checklist.item_groups.header': 'List Item {index}',
    'editbreak.steps.checklist.item_groups.reorder_toggle': 'Reorder items',
    'editbreak.steps.checklist.item.title': 'List Item Title',
    'editbreak.steps.checklist.item.description': 'List Item Description',
    'editbreak.steps.checklist.item.type': 'Choose Image Width',
    'editbreak.steps.checklist.item.type.none': 'None',
    'editbreak.steps.checklist.item.type.half': 'Half',
    'editbreak.steps.checklist.item.type.full': 'Full',
    'editbreak.steps.checklist.item.image': 'List Item Image',
    'editbreak.steps.checklist.result.reorder_toggle': 'Reorder results',
    'editbreak.steps.checklist.results_header': 'Results {index}',
    'editbreak.steps.checklist.result.header': 'Results {index}',
    'editbreak.steps.checklist.result.title': 'Results Title',
    'editbreak.steps.checklist.result.description': 'Results Description',
    'editbreak.steps.checklist.result.image': 'Results Image',
    'editbreak.steps.checklist.result.min_checked': 'Min Checked',
    'editbreak.steps.checklist.result.max_checked': 'Max Checked',

    // Complete
    'editbreak.steps.complete.heading': 'Step: Complete',
    'editbreak.steps.complete.heading.abv': 'Step: Complete',
    'editbreak.steps.complete.innerHeading': 'Complete: ',
    'editbreak.steps.complete.headline': 'Headline',
    'editbreak.steps.complete.intro_copy': 'Title Subhead',
    'editbreak.steps.complete.intro_copy.placeholder': 'Enter intro copy',
    'editbreak.steps.complete.body_copy': 'Body Copy',
    'editbreak.steps.complete.body_copy.placeholder': 'Enter Body Copy',
    'editbreak.steps.complete.complete_step_type': 'Type',
    'editbreak.steps.complete.complete_step_type.image': 'Image',
    'editbreak.steps.complete.complete_step_type.embed': 'Embed',
    'editbreak.steps.complete.complete_step_type.video': 'Video',
    'editbreak.steps.complete.image': 'Image',
    'editbreak.steps.complete.embed_code': 'Embed Code',
    'editbreak.steps.complete.video_id': 'Video ID',
    'editbreak.steps.complete.backgroundImage': 'Background Image',
    'editbreak.steps.complete.backgroundColor': 'Background Color',
    'editbreak.steps.complete.next_break_ids': 'Next Break URL Names',
    'editbreak.steps.complete.exclude_next_break_ids': 'Exclude From Next Break URL Names',

    // Custom HTML
    'editbreak.steps.custom_html.heading': 'Step: Custom HTML',
    'editbreak.steps.custom_html.heading.abv': 'Step: Custom HTML',
    'editbreak.steps.custom_html.innerHeading': 'Custom HTML: ',
    'editbreak.steps.custom_html.custom_css': 'Custom CSS',
    'editbreak.steps.custom_html.custom_html': 'Custom Code',
    'editbreak.steps.custom_html.headline': 'Headline',
    'editbreak.steps.custom_html.intro_copy': 'Title Subhead',
    'editbreak.steps.custom_html.intro_copy.placeholder': 'Enter intro copy',

    'editbreak.steps.custom_json.heading': 'Step: Custom JSON',
    'editbreak.steps.custom_json.innerHeading': 'Custom JSON: ',

    // Drag and Drop
    'editbreak.steps.drag_drop.heading': 'Step: Drag and Drop',
    'editbreak.steps.drag_drop.heading.abv': 'Step: Drag and Drop',
    'editbreak.steps.drag_drop.innerHeading': 'Drag and Drop: ',
    'editbreak.steps.drag_drop.headline': 'Headline',
    'editbreak.steps.drag_drop.example_image': 'Example Image',
    'editbreak.steps.drag_drop.intro_copy': 'Title Subhead',
    'editbreak.steps.drag_drop.intro_copy.placeholder': 'Enter intro copy',
    'editbreak.steps.drag_drop.body_copy': 'Body Copy',
    'editbreak.steps.drag_drop.body_copy.placeholder': 'Enter Body Copy',
    'editbreak.steps.drag_drop.type': 'Drag and Drop Type',
    'editbreak.steps.drag_drop.type.match': 'MatchDrop',
    'editbreak.steps.drag_drop.type.puzzle': 'PuzzleDrop',
    'editbreak.steps.drag_drop.puzzle_target_image': 'Puzzle Target Image',
    'editbreak.steps.drag_drop.force_correct_answer': 'Force Correct Answer',
    'editbreak.steps.drag_drop.shuffle_slots': 'Shuffle Target Order',
    'editbreak.steps.drag_drop.cards.puzzle_header': 'PuzzleDrop Images',
    'editbreak.steps.drag_drop.cards.puzzle_image': 'Puzzle Piece {sectionIndex}',
    'editbreak.steps.drag_drop.cards.match_header': 'MatchDrop Images',
    'editbreak.steps.drag_drop.cards.match_grid_size': 'Select Grid Size',
    'editbreak.steps.drag_drop.cards.match_drag_image': 'MatchDrop Drag Image {sectionIndex}',
    'editbreak.steps.drag_drop.cards.match_target_image': 'MatchDrop Target Image {sectionIndex}',
    'editbreak.steps.drag_drop.grid_size': 'Grid Size',
    'editbreak.steps.drag_drop.require_all_cards_placed': 'Require All Cards Placed',
    'editbreak.steps.drag_drop.grid_size.4': '4',
    'editbreak.steps.drag_drop.grid_size.8': '8',
    'editbreak.steps.drag_drop.grid_size.12': '12',

    // Filtering
    'editbreak.steps.filtering.heading': 'Step: Filtering',
    'editbreak.steps.filtering.heading.abv': 'Step: Filtering',
    'editbreak.steps.filtering.innerHeading': 'Filtering: ',
    'editbreak.steps.filtering.headline': 'Headline',
    'editbreak.steps.filtering.intro_copy': 'Title Subhead',
    'editbreak.steps.filtering.intro_copy.placeholder': 'Enter intro copy',
    'editbreak.steps.filtering.header_image': 'Header Image',
    'editbreak.steps.filtering.result_bg_color': 'Result Background Color',
    'editbreak.steps.filtering.result_layout': 'Result Detail Layout',
    'editbreak.steps.filtering.result_layout.single_column': 'Single Column',
    'editbreak.steps.filtering.result_layout.two_column': 'Two Columns',
    'editbreak.steps.filtering.dropdown.header': 'Dropdown',
    'editbreak.steps.filtering.dropdown.reorder_toggle': 'Reorder dropdowns',
    'editbreak.steps.filtering.dropdown.show_label': 'Show BasicLabel on Site?',
    'editbreak.steps.filtering.dropdown.label': 'Dropdown BasicLabel',
    'editbreak.steps.filtering.dropdown.items.header': 'Dropdown Item',
    'editbreak.steps.filtering.dropdown.items.reorder_toggle': 'Reorder dropdown items',
    'editbreak.steps.filtering.dropdown.items.text': 'Dropdown Item Name',
    'editbreak.steps.filtering.dropdown.items.value': 'Back-End Dropdown Name',
    'editbreak.steps.filtering.results.header': 'Result',
    'editbreak.steps.filtering.results.reorder_toggle': 'Reorder results',
    'editbreak.steps.filtering.results.title': 'Title',
    'editbreak.steps.filtering.results.image': 'Image',
    'editbreak.steps.filtering.results.sharing_on': 'Result Sharing On',
    'editbreak.steps.filtering.result.content.placement': 'Placement',
    'editbreak.steps.filtering.result.content.placement.left': 'Left',
    'editbreak.steps.filtering.result.content.placement.right': 'Right',
    'editbreak.steps.filtering.result.content.body_copy.text': 'Body Copy',
    'editbreak.steps.filtering.result.content.block_quote.value': 'Block Quote',
    'editbreak.steps.filtering.result.content.block_quote.value.placeholder': 'Enter block quote',
    'editbreak.steps.filtering.result.content.block_quote_source.value': 'Block Quote Source',
    'editbreak.steps.filtering.result.content.block_quote_source.value.placeholder': 'Enter blockquote source',
    'editbreak.steps.filtering.result.content.embed.code': 'Embed Code',
    'editbreak.steps.filtering.result.content.image.type': 'List item image style',
    'editbreak.steps.filtering.result.content.image.type.custom': 'Custom',
    'editbreak.steps.filtering.result.content.image.type.horizontal': 'Horizontal',
    'editbreak.steps.filtering.result.content.image.type.vertical': 'Vertical',
    'editbreak.steps.filtering.result.content.image.image': 'Select image from break',
    'editbreak.steps.filtering.result.content.image.scaling': 'Scale image to % of step width?',
    'editbreak.steps.filtering.result.content.image.scaling.none': 'No scaling',
    'editbreak.steps.filtering.result.content.image.scaling.65': '65%',
    'editbreak.steps.filtering.result.content.image.scaling.75': '75%',
    'editbreak.steps.filtering.result.content.button.text': 'Text',
    'editbreak.steps.filtering.result.content.button.url': 'URL',
    'editbreak.steps.filtering.result.content.button.text_color': 'Text Color',
    'editbreak.steps.filtering.result.content.button.bg_color': 'Bkgd Color',
    'editbreak.steps.filtering.result.content.reorder_toggle': 'Reorder result items',

    'editbreak.steps.gallery.heading': 'Step: Gallery',
    'editbreak.steps.gallery.innerHeading': 'Gallery: ',

    'editbreak.steps.gallery.hasVoting': 'Can users vote on items?',
    'editbreak.steps.gallery.hasItemSharing': 'Enable Social sharing for individual items',


    // Grocery Checklist
    'editbreak.steps.grocery.heading': 'Step: Grocery Checklist',
    'editbreak.steps.grocery.heading.abv': 'Step: Grocery Checklist',
    'editbreak.steps.grocery.innerHeading': 'Grocery Checklist: ',
    'editbreak.steps.grocery.title': 'Title',
    // 'editbreak.steps.grocery.header_image': 'Header Image',
    'editbreak.steps.grocery.copy': "Intro Copy",
    // 'editbreak.steps.grocery.intro_copy.placeholder':"Title Subhead",
    'editbreak.steps.grocery.contentLanguage': "Content Language",
    'editbreak.steps.grocery.contentLanguage.EN_US': "English",
    'editbreak.steps.grocery.contentLanguage.ES_LA': "Spanish",
    'editbreak.steps.grocery.headline':"Headline",
    'editbreak.steps.grocery.resultImage': "Result Image (730 x 392)",
    'editbreak.steps.grocery.genAiType': "Grocery Step variant: Gen AI?",

    'editbreak.steps.grocery.genAiPrompt': "Gen AI Prompt Text",

    // 'editbreak.steps.grocery.resultType': "Result Type",
    // 'editbreak.steps.grocery.resultType.numberChecked': "Number Checked",
    // 'editbreak.steps.grocery.resultType.decisionTree': "Decision Tree",
    // 'editbreak.steps.grocery.resultType.groceryList': "Grocery List",
    'editbreak.steps.grocery.genAiHeaderImage': "Gen AI Header Image (730 x 392)",
    'editbreak.steps.grocery.checklist.item.genAIPromptText': "Gen AI Prompt Text",
    'editbreak.steps.grocery.genAiResultsNumber': "Number of Gen Ai Results (e.g.: recipe suggestions)",
    'editbreak.steps.grocery.resultInclude': "Result will Include",
    'editbreak.steps.grocery.resultInclude.SELECTED': "Selected Items",
    'editbreak.steps.grocery.resultInclude.UNSELECTED': "Unselected Items",

    'editbreak.steps.grocery.resultDisplayFormat': "Result Format",
    'editbreak.steps.grocery.resultDisplayFormat.LIST': "Simple List",
    'editbreak.steps.grocery.resultDisplayFormat.CARDS': "Referral Cards",

    'editbreak.steps.grocery.resultOrderType': "Result Order",
    'editbreak.steps.grocery.resultOrderType.NATURAL': "As shown",
    'editbreak.steps.grocery.resultOrderType.ALPHABETICAL': "Alphabetically",

    'editbreak.steps.grocery.resultLink.header': "Result Dropdown Buttons (optional)",
    'editbreak.steps.grocery.resultLink.buttonCopy': "Button Copy",
    'editbreak.steps.grocery.resultLink.reorder_toggle': "Re-Order Buttons",
    'editbreak.steps.grocery.resultLink.section_header': "Result Button Links",


    'editbreak.steps.grocery.checklist.section_header': 'Checklist',
    'editbreak.steps.grocery.checklist_groups.item.header': 'Checklist Item',
    'editbreak.steps.grocery.checklist.reorder_toggle': 'Re-Order Checklists',

    'editbreak.steps.grocery.checklist.section_header': 'Checklist',

    'editbreak.steps.grocery.checklist.title': 'Title',
    'editbreak.steps.grocery.checklist.copy': 'Copy',


    'editbreak.steps.grocery.checklist.imageType': 'Image Type',
    'editbreak.steps.grocery.checklist.imageType.none': 'None',
    'editbreak.steps.grocery.checklist.imageType.square': 'Square',
    'editbreak.steps.grocery.checklist.imageType.vertical': 'Vertical',
    'editbreak.steps.grocery.checklist.imageType.horizontal': 'Horizontal',

    'editbreak.steps.grocery.checklist.image': 'Image',

    'editbreak.steps.grocery.checklist.item.reorder_toggle': 'Re-Order Items',
    'editbreak.steps.grocery.checklist.item.label': 'Checklist item text',
    'editbreak.steps.grocery.checklist.item.url': 'Button URL',
    'editbreak.steps.grocery.checklist.item.buttonCopy': 'Button copy',
    'editbreak.steps.grocery.checklist.item.image': 'Result Card Image 3:2 (600 x 400)',

    // Lead Gen
    'editbreak.steps.lead_gen.heading': 'Step: Lead Gen',
    'editbreak.steps.lead_gen.heading.abv': 'Step: Lead Gen',
    'editbreak.steps.lead_gen.innerHeading': 'Lead Gen: ',
    'editbreak.steps.lead_gen.headline': 'Headline',
    'editbreak.steps.lead_gen.intro_copy': 'Title Subhead',
    'editbreak.steps.lead_gen.intro_copy.placeholder': 'Enter intro copy for lead gen',
    'editbreak.steps.lead_gen.body_copy': 'Body Copy',
    'editbreak.steps.lead_gen.body_copy.placeholder': 'Enter Body Copy',
    'editbreak.steps.lead_gen.image': 'Header Image',
    'editbreak.steps.lead_gen.field': 'Field',
    'editbreak.steps.lead_gen.fields': 'Fields',
    'editbreak.steps.lead_gen.field.required': 'Required?',
    'editbreak.steps.lead_gen.field.custom_label': 'Custom BasicLabel',
    "editbreak.steps.lead_gen.field.firstName" : "First Name",
    "editbreak.steps.lead_gen.field.lastName" : "Last Name",
    "editbreak.steps.lead_gen.field.fullName" : "Full Name",
    "editbreak.steps.lead_gen.field.email" : "Email",
    "editbreak.steps.lead_gen.field.address" : "Address",
    "editbreak.steps.lead_gen.field.address2" : "Address 2",
    "editbreak.steps.lead_gen.field.city" : "City",
    "editbreak.steps.lead_gen.field.state" : "State",
    "editbreak.steps.lead_gen.field.zipCode" : "Zip Code",
    "editbreak.steps.lead_gen.field.phoneNumber" : "Phone Number",
    "editbreak.steps.lead_gen.field.mobileNumber" : "Mobile Number",
    "editbreak.steps.lead_gen.field.age" : "Age",
    "editbreak.steps.lead_gen.field.gender" : "Gender",
    "editbreak.steps.lead_gen.field.birthdayDay" : "Birthday Day",
    "editbreak.steps.lead_gen.field.birthdayMonth" : "Birthday Month",
    "editbreak.steps.lead_gen.field.birthdayYear" : "Birthday Year",
    "editbreak.steps.lead_gen.field.largeText" : "Large Text",
    "editbreak.steps.lead_gen.field.customText1" : "Custom Text 1",
    "editbreak.steps.lead_gen.field.customText2" : "Custom Text 2",
    "editbreak.steps.lead_gen.field.customText3" : "Custom Text 3",
    "editbreak.steps.lead_gen.field.image" : "Image",
    'editbreak.steps.lead_gen.confirmations.reorder_toggle': 'Reorder confirmations',
    'editbreak.steps.lead_gen.confirmations.name': 'Confirmation Name',
    'editbreak.steps.lead_gen.confirmations.text': 'Confirmation Text',
    'editbreak.steps.lead_gen.confirmations.required': 'Check Box Required?',
    'editbreak.steps.lead_gen.confirmations.prechecked': 'Pre-Check Box?',
    'editbreak.steps.lead_gen.confirmations.callback_url': 'Callback URL',
    'editbreak.steps.lead_gen.rules.header': 'Rules',
    'editbreak.steps.lead_gen.rules.has_minimum_age': 'Minimum Age Required?',
    'editbreak.steps.lead_gen.rules.minimum_age': 'Select Age Minimum',
    'editbreak.steps.lead_gen.rules.has_max_entries': 'Maximum Prize Entries?',
    'editbreak.steps.lead_gen.rules.max_entries': 'Select Prize Entries Maximum',
    'editbreak.steps.lead_gen.thanks.header': 'Thank You Page',
    'editbreak.steps.lead_gen.thanks.show_thanks': 'Show Thank You Page',
    'editbreak.steps.lead_gen.thanks.headline': 'Thank You Headline',
    'editbreak.steps.lead_gen.thanks.desc': 'Thank You Description',
    'editbreak.steps.lead_gen.thanks.image': 'Thank You Image',
    'editbreak.steps.lead_gen.fields.reorder_toggle': 'Reorder form fields',

    // Listicle
    'editbreak.steps.listicle.heading': 'Step: Listicle',
    'editbreak.steps.listicle.heading.abv': 'Step: Listicle',
    'editbreak.steps.listicle.innerHeading': 'Listicle: ',
    'editbreak.steps.listicle.headline': 'Headline',
    'editbreak.steps.listicle.header_image': 'List Header Image',
    'editbreak.steps.listicle.intro_copy': 'Title Subhead',
    'editbreak.steps.listicle.intro_copy.placeholder': 'Enter intro copy for listicle',
    'editbreak.steps.listicle.show_sharing_hover': 'Show Social Sharing Hover Bar?',
    'editbreak.steps.listicle.show_numbers': 'Show Numbered List?',
    'editbreak.steps.listicle.has_voting': 'Allow voting?',
    'editbreak.steps.listicle.has_voting_end_date': 'Set End Date for Voting?',
    'editbreak.steps.listicle.voting_end_date': 'Select Date and Time',
    'editbreak.steps.listicle.should_sort': 'Allow Re-Sorting Based on Up-Voting?',
    'editbreak.steps.listicle.default_upvote_text': 'Upvote/Positive Button Text',
    'editbreak.steps.listicle.default_upvote_icon': 'Upvote/Positive Button Icon',
    'editbreak.steps.listicle.default_downvote_text': 'Downvote/Negative Button Text',
    'editbreak.steps.listicle.default_downvote_icon': 'Downvote/Negative Button Icon',
    'editbreak.steps.listicle.item.reorder_toggle': 'Reorder list items',
    'editbreak.steps.listicle.item.content.reorder_toggle': "Reorder list content",
    'editbreak.steps.listicle.item.header': 'List Item {index}',
    'editbreak.steps.listicle.item.show_numbers': 'Show Number on this List Item?',
    'editbreak.steps.listicle.item.has_voting': 'Show Voting on this List Item?',
    'editbreak.steps.listicle.item.default_upvote_text': 'Upvote/Positive Button Text',
    'editbreak.steps.listicle.item.default_upvote_icon': 'Upvote/Positive Button Icon',
    'editbreak.steps.listicle.item.default_downvote_text': 'Downvote/Negative Button Text',
    'editbreak.steps.listicle.item.default_downvote_icon': 'Downvote/Negative Button Icon',
    'editbreak.steps.listicle.item.has_vote_tracking': 'Add Tracking to Voting Buttons?',
    'editbreak.steps.listicle.item.upvote_tags': 'Upvote/Positive Button Tracking',
    'editbreak.steps.listicle.item.downvote_tags': 'Downvote/Negative Button Tracking',
    'editbreak.steps.listicle.item.has_sharing': 'Show Sharing on this List Item?',
    'editbreak.steps.listicle.item.sharing_image': 'Optional Social Sharing Image',
    'editbreak.steps.listicle.item.add_to_calendar.btn_text': 'Button Text',
    'editbreak.steps.listicle.item.add_to_calendar.position': 'Button Position',
    'editbreak.steps.listicle.item.add_to_calendar.event.title': 'Event Title',
    'editbreak.steps.listicle.item.add_to_calendar.event.desc': 'Event Description',
    'editbreak.steps.listicle.item.add_to_calendar.event.location': 'Event Location',
    'editbreak.steps.listicle.item.add_to_calendar.event.starttime': 'Event Start Time',
    'editbreak.steps.listicle.item.add_to_calendar.event.endtime': 'Event End Time',
    'editbreak.steps.listicle.item.add_to_calendar.event.timezone': 'Event Time Zone',
    'editbreak.steps.listicle.item.block_quote.value': 'Block Quote',
    'editbreak.steps.listicle.item.block_quote.value.placeholder': 'Enter block quote',
    'editbreak.steps.listicle.item.block_quote_source.value': 'Block Quote Source',
    'editbreak.steps.listicle.item.block_quote_source.value.placeholder': 'Enter blockquote source',
    'editbreak.steps.listicle.item.old_body_copy.value': 'List item old body copy',
    'editbreak.steps.listicle.item.old_body_copy.value.placeholder': 'Enter listicle old body copy',
    'editbreak.steps.listicle.item.body_copy.value': 'List item body copy',
    'editbreak.steps.listicle.item.body_copy.value.placeholder': 'Enter listicle body',
    'editbreak.steps.listicle.item.image.type': 'List item image style',
    'editbreak.steps.listicle.item.image.type.custom': 'Custom',
    'editbreak.steps.listicle.item.image.type.horizontal': 'Horizontal',
    'editbreak.steps.listicle.item.image.type.vertical': 'Vertical',
    'editbreak.steps.listicle.item.image.image': 'Select image from break',
    'editbreak.steps.listicle.item.image.scaling': 'Scale image to % of step width?',
    'editbreak.steps.listicle.item.image.scaling.none': 'No scaling',
    'editbreak.steps.listicle.item.image.scaling.65': '65%',
    'editbreak.steps.listicle.item.image.scaling.75': '75%',
    'editbreak.steps.listicle.item.embed_code.value': 'Embed Code',
    'editbreak.steps.listicle.item.embed_code.value.placeholder': 'Enter embed code',
    'editbreak.steps.listicle.item.button.text': 'Text',
    'editbreak.steps.listicle.item.button.url': 'URL',
    'editbreak.steps.listicle.item.button.text_color': 'Text Color',
    'editbreak.steps.listicle.item.button.bg_color': 'Bkgd Color',
    'editbreak.steps.listicle.item.image_comparison.left_image': 'Left Image',
    'editbreak.steps.listicle.item.image_comparison.right_image': 'Right Image',
    'editbreak.steps.listicle.item.image_comparison.start_position': 'Initial Slider Position',
    'editbreak.steps.listicle.item.image_comparison.start_position.left': 'Left',
    'editbreak.steps.listicle.item.image_comparison.start_position.center': 'Center',
    'editbreak.steps.listicle.item.image_comparison.start_position.right': 'Right',
    'editbreak.steps.listicle.item.dynamics': 'Dynamic Content Visibility',
    'editbreak.steps.listicle.item.subhead': 'List item subhead',
    'editbreak.steps.listicle.item.subhead.placeholder': 'Enter listicle subhead',
    'editbreak.steps.listicle.item.layout.layoutRow': 'Row',
    'editbreak.steps.listicle.item.layout.layoutColumn': 'Column',

    'editbreak.steps.media_upload.heading': 'Step: Media Upload',
    'editbreak.steps.media_upload.innerHeading': 'Media Upload: ',


    // Memory Match
    'editbreak.steps.memory_match.heading': 'Step: Memory Match',
    'editbreak.steps.memory_match.heading.abv': 'Step: Memory Match',
    'editbreak.steps.memory_match.innerHeading': 'Memory Match: ',
    'editbreak.steps.memory_match.headline': 'Headline',
    'editbreak.steps.memory_match.intro_copy': 'Title Subhead',
    'editbreak.steps.memory_match.intro_copy.placeholder': 'Enter intro copy for Memory Match',
    'editbreak.steps.memory_match.bgColor': 'Bkgd Color',
    'editbreak.steps.memory_match.grid_size': 'Select Grid Size',
    'editbreak.steps.memory_match.grid_size.8': '8',
    'editbreak.steps.memory_match.grid_size.12': '12',
    'editbreak.steps.memory_match.grid_size.16': '16',
    'editbreak.steps.memory_match.defaultFrontImage': 'Card Front Image',
    'editbreak.steps.memory_match.cards': 'Memory Match Cards',
    'editbreak.steps.memory_match.card.rear_image': 'Card Pair {sectionIndex}',

    // Personality Quiz
    'editbreak.steps.personality_quiz.heading': 'Step: Personality Quiz',
    'editbreak.steps.personality_quiz.heading.abv': 'Step: PQ',
    'editbreak.steps.personality_quiz.innerHeading': 'Personality Quiz: ',
    'editbreak.steps.personality_quiz.decision_tree.accordion_heading': 'Decision Tree Setup',
    'editbreak.steps.personality_quiz.suggestion_header': 'Step suggestions',
    'editbreak.steps.personality_quiz.suggestion_text': 'Quizzes should be limited to five questions and between two to six sets of answers/results. It is recommended to have the same number of answers and results.',
    'editbreak.steps.personality_quiz.headline': 'Headline',
    'editbreak.steps.personality_quiz.intro_copy': 'Title Subhead',
    'editbreak.steps.personality_quiz.intro_copy.placeholder': 'Enter intro copy for Personality',
    'editbreak.steps.personality_quiz.answer_button_bg_color': 'Answer Button Bkgd Color',
    'editbreak.steps.personality_quiz.answer_button_text_color': 'Answer Button Text Color',
    'editbreak.steps.personality_quiz.answer_button_border_color': 'Answer Button Border Color',

    'editbreak.steps.personality_quiz.backgroundImage': 'Background Image',
    'editbreak.steps.personality_quiz.backgroundColor': 'Background Color',

    'editbreak.steps.personality_quiz.questionBackgroundImage': 'Question Background Image',
    'editbreak.steps.personality_quiz.questionBackgroundColor': 'Question Background Color',


    'editbreak.steps.personality_quiz.result_type': 'Result Display Type',
    'editbreak.steps.personality_quiz.result_type.decision_tree': 'Decision Tree',
    'editbreak.steps.personality_quiz.result_type.decision_tree.select_all': 'Select All',
    'editbreak.steps.personality_quiz.result_type.decision_tree.reset': 'Reset',
    'editbreak.steps.personality_quiz.result_type.list_chosen': 'List of Results',
    'editbreak.steps.personality_quiz.result_type.list_chosen.headline': 'List Result Headline',
    'editbreak.steps.personality_quiz.result_type.list_chosen.headline.placeholder': 'Enter Headline',
    'editbreak.steps.personality_quiz.result_type.list_chosen.description': 'Result Description Copy',
    'editbreak.steps.personality_quiz.result_type.list_chosen.description.placeholder': 'Enter Description Copy',
    'editbreak.steps.personality_quiz.result_type.most_chosen': 'Single Result',
    'editbreak.steps.personality_quiz.result.reorder_toggle': 'Reorder results',
    'editbreak.steps.personality_quiz.result.header': 'Result {index}',
    'editbreak.steps.personality_quiz.result.title': 'Result Title',
    'editbreak.steps.personality_quiz.result.title.placeholder': 'Enter title',
    'editbreak.steps.personality_quiz.result.description': 'Result Description',
    'editbreak.steps.personality_quiz.result.videoId': 'Video ID',
    'editbreak.steps.personality_quiz.result.description.placeholder': 'Enter description for result',
    'editbreak.steps.personality_quiz.result.image': 'Result Image',
    'editbreak.steps.personality_quiz.result.layout': 'Result Layout',
    'editbreak.steps.personality_quiz.result.layout.one_column': '1 Column',
    'editbreak.steps.personality_quiz.result.layout.two_column': '2 Columns',
    'editbreak.steps.personality_quiz.result.has_share_image': 'Use a Different Image for Social Sharing?',
    'editbreak.steps.personality_quiz.result.share_image': 'Social Share Image',
    'editbreak.steps.personality_quiz.result.link_url': 'Result URL',
    'editbreak.steps.personality_quiz.result.link_text': 'Result URL Text',

    'editbreak.steps.personality_quiz.result.backgroundImage': 'Background Image',
    'editbreak.steps.personality_quiz.result.backgroundColor': 'Background Color',

    'editbreak.steps.personality_quiz.result.user_tags.header': 'User Tag',
    'editbreak.steps.personality_quiz.result.user_tags.reorder_toggle': 'Reorder user tags',
    'editbreak.steps.personality_quiz.result.user_tags.tag_id': 'Tag',
    'editbreak.steps.personality_quiz.result.user_tags.point_weight': 'Point Weight',
    'editbreak.steps.personality_quiz.question.reorder_toggle': 'Reorder questions',
    'editbreak.steps.personality_quiz.question.header': 'Question {index}',
    'editbreak.steps.personality_quiz.question.type': 'Question Type',
    'editbreak.steps.personality_quiz.question.type.text': 'TEXT',
    'editbreak.steps.personality_quiz.question.type.image': 'IMAGE',
    'editbreak.steps.personality_quiz.question.text': 'Question {sectionIndex}',
    'editbreak.steps.personality_quiz.question.image': 'Question Image',
    'editbreak.steps.personality_quiz.question.show_overlay': 'Show Color Overlay',
    'editbreak.steps.personality_quiz.answer.reorder_toggle': 'Reorder answers',
    'editbreak.steps.personality_quiz.answer.header': 'Answer {index}',
    'editbreak.steps.personality_quiz.answer.type': 'Answer Type',
    'editbreak.steps.personality_quiz.answer.hideText': 'Hide Text',
    'editbreak.steps.personality_quiz.answer.type.text': 'TEXT',
    'editbreak.steps.personality_quiz.answer.type.image': 'IMAGE',
    'editbreak.steps.personality_quiz.answer.text': 'Answer {sectionIndex}',
    'editbreak.steps.personality_quiz.answer.image': 'Answer Image',
    'editbreak.steps.personality_quiz.answer.connected_result': 'Connected Result',
    'editbreak.steps.personality_quiz.answer.edit_button_colors': 'Edit Button Colors?',
    'editbreak.steps.personality_quiz.answer.bg_color': 'Answer Button Bkgd Color',
    'editbreak.steps.personality_quiz.answer.text_color': 'Answer Button Text Color',
    'editbreak.steps.personality_quiz.answer.user_tags.header': 'User Tag',
    'editbreak.steps.personality_quiz.answer.user_tags.reorder_toggle': 'Reorder user tags',
    'editbreak.steps.personality_quiz.answer.user_tags.tag_id': 'Tag',
    'editbreak.steps.personality_quiz.answer.user_tags.point_weight': 'Point Weight',

    'editbreak.steps.personality_quiz.keyvaluepairs.header': 'Key/Value pairs',
    'editbreak.steps.personality_quiz.keyvaluepair': 'Key/Value pair',
    'editbreak.steps.personality_quiz.keyvaluepair.key': 'Key',
    'editbreak.steps.personality_quiz.keyvaluepair.value': 'Value',



    // Pinterest
    'editbreak.steps.pinterest.heading': 'Step: Pinterest',
    'editbreak.steps.pinterest.heading.abv': 'Step: Pinterest',
    'editbreak.steps.pinterest.innerHeading': 'Pinterest: ',
    'editbreak.steps.pinterest.headline': 'Headline',
    'editbreak.steps.pinterest.intro_copy': 'Title Subhead',
    'editbreak.steps.pinterest.intro_copy.placeholder': 'Enter intro for Pinterest',
    'editbreak.steps.pinterest.body_copy': 'Body Copy',
    'editbreak.steps.pinterest.body_copy.placeholder': 'Enter Body Copy',
    'editbreak.steps.pinterest.display_type': 'Display Type',
    'editbreak.steps.pinterest.display_type.pins': 'Pins',
    'editbreak.steps.pinterest.display_type.board': 'Board',
    'editbreak.steps.pinterest.pin_ids': 'Pin IDs',
    'editbreak.steps.pinterest.board_url': 'Board URL',

    // Poll
    'editbreak.steps.poll.heading': 'Step: Poll',
    'editbreak.steps.poll.heading.abv': 'Step: Poll',
    'editbreak.steps.poll.innerHeading': 'Poll: ',
    'editbreak.steps.poll.headline': 'Headline',
    'editbreak.steps.poll.intro_copy': 'Title Subhead',
    'editbreak.steps.poll.intro_copy.placeholder': 'Enter intro copy for poll',
    'editbreak.steps.poll.header_image': 'Header Image',
    'editbreak.steps.poll.answerButtonBorder': 'Answer Button Border',
    'editbreak.steps.poll.answerButtonText': 'Answer Button Text',
    'editbreak.steps.poll.answerButtonBorderHover': 'Answer Button Border Hover',
    'editbreak.steps.poll.nextQuestionButtonBackground': 'Next Question Button Background',
    'editbreak.steps.poll.nextQuestionButtonText': 'Next Question Button Text',
    'editbreak.steps.poll.nextQuestionButtonBackgroundHover': 'Next Question Button Background Hover',
    'editbreak.steps.poll.dropdownButtonBackground': 'Dropdown Button Background',
    'editbreak.steps.poll.dropdownButtonText': 'Dropdown Button Text',
    'editbreak.steps.poll.dropdownButtonBackgroundHover': 'Dropdown Button Background Hover',
    'editbreak.steps.poll.dropdown_button.edit_colors': 'Edit Button Colors?',
    'editbreak.steps.poll.question.reorder_toggle': 'Reorder questions',
    'editbreak.steps.poll.question.header': 'Question {index}',
    'editbreak.steps.poll.question.question': 'Question {sectionIndex}',
    'editbreak.steps.poll.question.image': 'Question Image',
    'editbreak.steps.poll.question.use_default_image': 'Use Default Image?',
    'editbreak.steps.poll.question.default_image': 'Default Image',
    'editbreak.steps.poll.question.type': 'Question Type',
    'editbreak.steps.poll.question.type.text': 'Text',
    'editbreak.steps.poll.question.type.video': 'Video',
    'editbreak.steps.poll.question.answer.header': 'Answer {index}',
    'editbreak.steps.poll.question.answer': 'Answer {sectionIndex}',
    'editbreak.steps.poll.question.social_share_image': 'Optional Social Sharing Image',
    'editbreak.steps.poll.question.video_embed': 'Video Embed Code',
    'editbreak.steps.poll.question.result_text': 'Question Result Text',
    'editbreak.steps.poll.question.result_image': 'Question Result Image',
    'editbreak.steps.poll.question.edit_result_graph_colors': 'Edit Result Graph Colors?',
    'editbreak.steps.poll.question.result.user_selection_result_bar_color': 'User Selection Bar Color',
    'editbreak.steps.poll.question.result.other_selections_result_bar_color' : 'Not Selected Bar Color',
    'editbreak.steps.poll.dropdown_button.bgColor': 'Dropdown Button Background Color',
    'editbreak.steps.poll.dropdown_button.textColor': 'Dropdown Button Text Color',
    'editbreak.steps.poll.dropdown_button.bgHoverColor': 'Dropdown Button Background Hover Color',
    'editbreak.steps.poll.answer.reorder_toggle': 'Reorder answers',
    'editbreak.steps.poll.answer.type': 'Answer Type',
    'editbreak.steps.poll.answer.type.text': 'Text',
    'editbreak.steps.poll.answer.type.image': 'Image',
    'editbreak.steps.poll.answer.image': 'Answer Image',
    'editbreak.steps.poll.answer.editButtonColors': 'Edit Button Colors?',
    'editbreak.steps.poll.answer.bgColor': 'Answer Button Bkgd Color',
    'editbreak.steps.poll.answer.bgHoverColor': 'Answer Button Bkgd Hover Color',
    'editbreak.steps.poll.answer.textColor': 'Answer Button Text',
    'editbreak.steps.poll.answer.textHoverColor': 'Answer Button Text Hover',
    'editbreak.steps.poll.answer.user_tags.header': 'User Tag',
    'editbreak.steps.poll.answer.user_tags.reorder_toggle': 'Reorder user tags',
    'editbreak.steps.poll.answer.user_tags.tag_id': 'Tag',
    'editbreak.steps.poll.answer.user_tags.point_weight': 'Point Weight',

    // Puzzle
    'editbreak.steps.puzzle.heading': 'Step: Puzzle',
    'editbreak.steps.puzzle.heading.abv': 'Step: Puzzle',
    'editbreak.steps.puzzle.innerHeading': 'Puzzle: ',
    'editbreak.steps.puzzle.headline': 'Headline',
    'editbreak.steps.puzzle.intro_copy': 'Title Subhead',
    'editbreak.steps.puzzle.body_copy': 'Body Copy',
    'editbreak.steps.puzzle.commentQuestion': 'Facebook Comment Question',
    'editbreak.steps.puzzle.imageId': 'Image',
    'editbreak.steps.puzzle.targetImageId': 'Target Image',
    'editbreak.steps.puzzle.rows': 'Rows',
    'editbreak.steps.puzzle.columns': 'Columns',

    // Receipt Verification
    'editbreak.steps.receipt_verification.heading': 'Step: Receipt Verification',
    'editbreak.steps.receipt_verification.heading.abv': 'Step: Receipt',
    'editbreak.steps.receipt_verification.innerHeading': 'Receipt Verification: ',
    'editbreak.steps.receipt_verification.headline': 'Headline',
    'editbreak.steps.receipt_verification.intro_copy': 'Title Subhead',
    'editbreak.steps.receipt_verification.intro_copy.placeholder': 'Enter intro copy for Receipt Verification',
    'editbreak.steps.receipt_verification.header_image': 'Header Image',
    'editbreak.steps.receipt_verification.test_snipp_campaign_id': 'Test Promotion ID',
    'editbreak.steps.receipt_verification.snipp_campaign_id': 'Promotion ID',
    'editbreak.steps.receipt_verification.reminder_btn_text': 'Reminder Button Text',
    'editbreak.steps.receipt_verification.step_terms': 'Legal Terms',
    'editbreak.steps.receipt_verification.instruction.reorder_toggle': 'Reorder instructions',
    'editbreak.steps.receipt_verification.instruction.headline': 'Instruction Headline',
    'editbreak.steps.receipt_verification.instruction.headline_text_color': 'Headline Text Color',
    'editbreak.steps.receipt_verification.instruction.description': 'Instruction Description',
    'editbreak.steps.receipt_verification.instruction.add_details': 'Add Details?',
    'editbreak.steps.receipt_verification.instruction.detail_headline': 'Detail Headline',
    'editbreak.steps.receipt_verification.instruction.detail_description': 'Detail Description',
    'editbreak.steps.receipt_verification.instruction.detail_image': 'Detail Image',
    'editbreak.steps.receipt_verification.instruction.detail_bg_color': 'Detail Background Color',
    'editbreak.steps.receipt_verification.instruction.icon_type': 'Icon Type',
    'editbreak.steps.receipt_verification.instruction.icon_type.icon': 'Icon',
    'editbreak.steps.receipt_verification.instruction.icon_type.image': 'Image',
    'editbreak.steps.receipt_verification.instruction.icon.id': 'Font Awesome ID',
    'editbreak.steps.receipt_verification.instruction.icon.color': 'Icon Font Color',
    'editbreak.steps.receipt_verification.instruction.icon.size': 'Icon Size',
    'editbreak.steps.receipt_verification.instruction.icon.bg_color': 'Icon Background Color',
    'editbreak.steps.receipt_verification.instruction.icon.border_color': 'Icon Border Color',
    'editbreak.steps.receipt_verification.instruction.image': 'Icon Image',
    'editbreak.steps.receipt_verification.instruction.image.bg_color': 'Icon Background Color',
    'editbreak.steps.receipt_verification.instruction.image.border_color': 'Icon Border Color',
    'editbreak.steps.receipt_verification.requirements': 'Requirements',
    'editbreak.steps.receipt_verification.requirements.reorder_toggle': 'Reorder requirements',
    'editbreak.steps.receipt_verification.requirements.header': 'Requirements Header',
    'editbreak.steps.receipt.requirements.header': 'Requirement Item',
    'editbreak.steps.receipt_verification.requirement.description': 'Requirement Item Text',
    'editbreak.steps.receipt_verification.submission_section': 'Submission',
    'editbreak.steps.receipt_verification.submission.submitted_text': 'Submitted Text',
    'editbreak.steps.receipt_verification.submission.verification_pending_text': 'Verification Pending Text',
    'editbreak.steps.receipt_verification.submission.submission_limit': 'Submission Limit',
    'editbreak.steps.receipt_verification.submission.submission_cutoff': 'Submission Cutoff',
    'editbreak.steps.receipt_verification.submission.approvedReceiptsPerUserLimit': 'Approved Receipts Per User Limit',
    'editbreak.steps.receipt_verification.submission.approvedReceiptsPerUserLimitType': 'Approved Receipts Per User Limit Type (duration)',
    'editbreak.steps.receipt_verification.submission.next_break_url_ids': 'Next Break URL Names',
    'editbreak.steps.receipt_verification.submission.exclude_next_break_ids': 'Exclude From Next Break URL Names',
    'editbreak.steps.receipt_verification.submitted_email_data': 'Submission Email',
    'editbreak.steps.receipt_verification.submitted_email_data.title': 'Submitted Email Title',
    'editbreak.steps.receipt_verification.submitted_email_data.body': 'Submitted Email Body Text',
    'editbreak.steps.receipt_verification.submitted_email_data.privacy_policy': 'Submitted Email Privacy Policy',
    'editbreak.steps.receipt_verification.submitted_email_data.privacy_policy_link': 'Submitted Email Policy Link',
    'editbreak.steps.receipt_verification.submitted_email_data.footer': 'Submitted Email Legal Copy',
    'editbreak.steps.receipt_verification.submitted_email_data.client_logo': 'Client Logo',
    'editbreak.steps.receipt_verification.reward_section': 'Reward',
    'editbreak.steps.receipt_verification.reward_section.type': 'Reward Type',
    'editbreak.steps.receipt_verification.reward_section.type.points': 'Points',
    'editbreak.steps.receipt_verification.reward_section.type.vendor_digital': 'Vendor Reward - Digital',
    'editbreak.steps.receipt_verification.reward_section.type.vendor_physical': 'Vendor Reward - Physical',
    'editbreak.steps.receipt_verification.reward_section.type.internal_sweepstakes': 'Internal Sweepstakes Reward',
    'editbreak.steps.receipt_verification.reward_section.point_reward': 'Point Reward',
    'editbreak.steps.receipt_verification.reward_section.vendor_reward_id': 'Vendor Reward ID',
    'editbreak.steps.receipt_verification.reward_section.vendor_campaign_id': 'Vendor Campaign ID',
    'editbreak.steps.receipt_verification.reward_section.internal_sweepstakes_id': 'Sweepstakes Reward ID',
    'editbreak.steps.receipt_verification.reward_section.require_address': 'Require Physical Address',
    'editbreak.steps.receipt_verification.on_site_result_section': 'On-Site Result Notifications',
    'editbreak.steps.receipt_verification.on_site_result_section.rejected_text': 'Rejected Text',
    'editbreak.steps.receipt_verification.on_site_result_section.approved_text': 'Approved Text',
    'editbreak.steps.receipt_verification.nextBreakIds': 'Next Break URL Names',
    'editbreak.steps.receipt_verification.excludeNextBreakIdList': 'Exclude From Next Break URL Names',
    'editbreak.steps.receipt_verification.on_site_result_section.support_email': 'Support Email',
    'editbreak.steps.receipt_verification.on_site_result_section.support_phone': 'Support Phone',
    'editbreak.steps.receipt_verification.approved_email_data': 'Approval Email',
    'editbreak.steps.receipt_verification.approved_email_data.title': 'Approval Email Title',
    'editbreak.steps.receipt_verification.approved_email_data.body': 'Approval Email Body Text',
    'editbreak.steps.receipt_verification.approved_email_data.privacy_policy': 'Approval Email Privacy Policy',
    'editbreak.steps.receipt_verification.approved_email_data.privacy_policy_link': 'Approval Email Policy Link',
    'editbreak.steps.receipt_verification.approved_email_data.footer': 'Approval Email Legal Copy',
    'editbreak.steps.receipt_verification.approved_email_data.client_logo': 'Client Logo',
    'editbreak.steps.receipt_verification.rejected_email_data': 'Rejected Email',
    'editbreak.steps.receipt_verification.rejected_email_data.title': 'Rejected Email Title',
    'editbreak.steps.receipt_verification.rejected_email_data.body': 'Rejected Email Body Text',
    'editbreak.steps.receipt_verification.rejected_email_data.privacy_policy': 'Rejected Email Privacy Policy',
    'editbreak.steps.receipt_verification.rejected_email_data.privacy_policy_link': 'Rejected Email Policy Link',
    'editbreak.steps.receipt_verification.rejected_email_data.footer': 'Rejected Email Legal Copy',
    'editbreak.steps.receipt_verification.rejected_email_data.client_logo': 'Client Logo',
    'editbreak.steps.receipt_verification.escrow_section': 'Prizing Budget',

    // Referral
    'editbreak.steps.referral.heading': 'Step: Referral',
    'editbreak.steps.referral.heading.abv': 'Step: Referral',
    'editbreak.steps.referral.innerHeading': 'Referral: ',
    'editbreak.steps.referral.headline': 'Referral Headline',
    'editbreak.steps.referral.headline.placeholder': 'Enter the referral headline',
    'editbreak.steps.referral.layout': 'Layout',
    'editbreak.steps.referral.layout.single_column': 'Single Column',
    'editbreak.steps.referral.layout.two_column': 'Two Column',
    'editbreak.steps.referral.layout.three_column': 'Three Column',
    'editbreak.steps.referral.intro_copy': 'Title Subhead',
    'editbreak.steps.referral.intro_copy.placeholder': 'Enter Title Subhead',
    'editbreak.steps.referral.header_image': 'Header Image (1490 x 756)',
    'editbreak.steps.referral.header_image.3x2': 'Referral Image (3:2)',
    'editbreak.steps.referral.top_text': 'Top Text',
    'editbreak.steps.referral.top_text.placeholder': 'Enter top text',
    'editbreak.steps.referral.bottom_text': 'Bottom Text',
    'editbreak.steps.referral.bottom_text.placeholder': 'Enter bottom text',
    'editbreak.steps.referral.default_button_color': 'Default Button Color',
    'editbreak.steps.referral.link.header': 'Referral {index}',
    'editbreak.steps.referral.link.url': 'Referral URL',
    'editbreak.steps.referral.menu.hasCustomColors': 'Specify Custom Colors',
    'editbreak.steps.referral.menu.backgroundColor': 'Menu Background Color',
    'editbreak.steps.referral.menu.textColor': 'Menu Text Color',
    'editbreak.steps.referral.menu.hoverBackgroundColor': 'Menu Hover Color',
    'editbreak.steps.referral.menu.hoverTextColor': 'Menu Hover Text Color',
    'editbreak.steps.referral.link.show_button': 'Show Button?',
    'editbreak.steps.referral.link.headline': 'Referral Headline',
    'editbreak.steps.referral.link.intro_copy': 'Title Subhead',
    'editbreak.steps.referral.link.intro_copy.placeholder': 'Enter intro copy',
    'editbreak.steps.referral.link.reorder_toggle': "Reorder links",
    'editbreak.steps.referral.link.button_color': "Button color",
    'editbreak.steps.referral.link.header_image': 'Multi Referral Image',
    'editbreak.steps.referral.link.header_image.3x2': 'Referral Image (3:2)',
    'editbreak.steps.referral.link.cta_type': 'Call to Action Type',
    'editbreak.steps.referral.link.cta_type.button': 'Button',
    'editbreak.steps.referral.link.cta_type.text': 'Text',
    'editbreak.steps.referral.link.cta_type.menu': 'Menu',
    'editbreak.steps.referral.menu.header': 'Menu',
    'editbreak.steps.referral.link.cta.text': 'Referral {sectionIndex} CTA Text',
    'editbreak.steps.referral.link.cta.button_text': 'Referral {sectionIndex} CTA Button Text',
    'editbreak.steps.referral.link.cta.top_text': 'Additional Copy Above CTA',
    'editbreak.steps.referral.link.cta.bottom_text': 'Additional Copy Below CTA',
    'editbreak.steps.referral.link.has_goal': 'Click Goal (Show Progress Bar)',
    'editbreak.steps.referral.link.goal': 'Goal',
    'editbreak.steps.referral.link.bar_color': 'Bar Color',
    'editbreak.steps.referral.link.bar_highlight_color': 'Bar highlight color',
    'editbreak.steps.referral.link.bar_complete_color': 'Bar complete color',
    'editbreak.steps.referral.link.tracking_type': 'Tracking Type',
    'editbreak.steps.referral.link.tracking_type.referral': 'Referral',
    'editbreak.steps.referral.link.tracking_type.coupon': 'Coupon',
    'editbreak.steps.referral.link.uses_coupons_dot_com': 'Using Coupons.com?',
    'editbreak.steps.referral.link.cdc_short_cipher': 'Coupons.com Short Cipher',
    'editbreak.steps.referral.link.cdc_long_cipher': 'Coupons.com Long Cipher',

    // Review
    'editbreak.steps.review.heading': 'Step: Review',
    'editbreak.steps.review.heading.abv': 'Step: Review',
    'editbreak.steps.review.innerHeading': 'Review: ',
    'editbreak.steps.review.fields.title': 'Title',
    'editbreak.steps.review.reminder.enable': 'Enable Review Reminders',
    'editbreak.steps.review.product.reorder_toggle': 'Reorder products',
    'editbreak.steps.review.product': 'Product',
    'editbreak.steps.review.product.bv_id': 'BazaarVoice Product ID',
    'editbreak.steps.review.product.bv_api_key': 'BazaarVoice API Key',
    'editbreak.steps.review.product.bv_encoding_key': 'BazaarVoice Encoding Key',
    'editbreak.steps.review.product.title': 'Product Title',
    'editbreak.steps.review.product.dropdown_title': 'Product Title (dropdowns)',
    'editbreak.steps.review.product.description': 'Description',
    'editbreak.steps.review.product.image': 'Image (3x2)',

    'editbreak.steps.review.product.reminder.break_url': 'Break URL',
    'editbreak.steps.review.product.reminder.button_url': 'Button URL',
    'editbreak.steps.review.product.reminder.button_copy': 'Button Copy',

    'editbreak.steps.review.product.reminder.confirmation_header': 'Header copy',
    'editbreak.steps.review.product.reminder.confirmation_body': 'Body copy',
    'editbreak.steps.review.product.reminder.confirmation_footer': 'Legal/Footer copy',

    'editbreak.steps.review.sample_review.rating': 'Rating',
    'editbreak.steps.review.sample_review.reorder_toggle' : 'Reorder',
    // 'editbreak.steps.review.sample_review.header': 'Sample Review {index}',
    'editbreak.steps.review.sample_review.title': 'Title',
    'editbreak.steps.review.sample_review.detail': 'Detail',
    'editbreak.steps.review.sample_review.rating': 'Rating (1-5)',
    'editbreak.steps.review.sample_review.nickname': 'Nickname',

    'editbreak.steps.review.reminder.heading': 'Review Reminder Settings',
    'editbreak.steps.review.reminder.enable': 'Enable Reminder Flow',
    'editbreak.steps.review.reminder.notFamiliarCopy': 'Skip Product Selector copy',

    'editbreak.steps.review.fields.reminderThankyouHeader': 'Thank you - header',
    'editbreak.steps.review.fields.reminderThankyouIntro': 'Thank you - intro',
    'editbreak.steps.review.fields.reminderThankyouBody': 'Thank you - body',
    'editbreak.steps.review.fields.reminderThankyouBodyButton': 'Thank you - button copy',
    'editbreak.steps.review.fields.reminderThankyouBodyButtonUrl': 'Thank you - button url',


    // Spot The Difference
    'editbreak.steps.spot_difference.heading': 'Step: Spot the Difference',
    'editbreak.steps.spot_difference.heading.abv': 'Step: STD',
    'editbreak.steps.spot_difference.innerHeading': 'Spot the Difference: ',
    'editbreak.steps.spot_the_difference.headline': 'Headline',
    'editbreak.steps.spot_the_difference.intro_copy': 'Title Subhead',
    'editbreak.steps.spot_the_difference.intro_copy.placeholder': 'Enter intro copy for Spot the Difference',
    'editbreak.steps.spot_the_difference.button_text': 'Button Text',
    'editbreak.steps.spot_the_difference.example_image': 'Example Image',
    'editbreak.steps.spot_the_difference.instruction.reorder_toggle': 'Reorder instructions',
    'editbreak.steps.spot_the_difference.instruction.header': 'Instruction {index}',
    'editbreak.steps.spot_the_difference.instruction.headline': 'Instruction Headline',
    'editbreak.steps.spot_the_difference.instruction.description': 'Instruction Description',
    'editbreak.steps.spot_the_difference.scene.header': 'Scene {index}',
    'editbreak.steps.spot_the_difference.scene.reorder_toggle': "Reorder scenes",
    'editbreak.steps.spot_the_difference.scene.headline': 'Headline',
    'editbreak.steps.spot_the_difference.scene.time_limit': 'Time Limit',
    'editbreak.steps.spot_the_difference.scene.original_image': 'Original Image',
    'editbreak.steps.spot_the_difference.scene.differences_image': 'Differences Image',


    // Store Finder
    'editbreak.steps.store_finder.heading': 'Step: Store Finder',
    'editbreak.steps.store_finder.heading.abv': 'Step: Store Finder',
    'editbreak.steps.store_finder.innerHeading': 'Store Finder: ',
    'editbreak.steps.store_finder.headline': 'Headline',
    'editbreak.steps.store_finder.custom_icon': 'Custom Map Icon',
    'editbreak.steps.store_finder.intro_copy': 'Title Subhead',
    'editbreak.steps.store_finder.intro_copy.placeholder': 'Enter intro copy for text above map',
    'editbreak.steps.store_finder.body_copy': 'Body Copy',
    'editbreak.steps.store_finder.body_copy.placeholder': 'Enter Body Copy',
    'editbreak.steps.store_finder.zoom_level': 'Zoom Level',
    'editbreak.steps.store_finder.client_id': 'Client ID',
    'editbreak.steps.store_finder.upload_locations': "Upload Store Finder Data",
    'editbreak.steps.store_finder.status_message.submitted': "File being processed | Current Status: Submitted",
    'editbreak.steps.store_finder.status_message.running': "File being processed | Current Status: Running",
    'editbreak.steps.store_finder.status_message.complete': "File being processed | Current Status: Complete",
    'editbreak.steps.store_finder.status_message.error': "File being processed | Current Status: Error",
    'editbreak.steps.store_finder.file_description' : 'Date: {date} | Locations: {rowCount}',

    // Text Trivia
    'editbreak.steps.text_trivia.heading': 'Step: Text Trivia',
    'editbreak.steps.text_trivia.heading.abv': 'Step: Text Trivia',
    'editbreak.steps.text_trivia.innerHeading': 'Text Trivia: ',
    'editbreak.steps.text_trivia.headline': 'Headline',
    'editbreak.steps.text_trivia.intro_copy': 'Title Subhead',
    'editbreak.steps.text_trivia.intro_copy.placeholder': 'Enter intro copy for trivia',
    'editbreak.steps.text_trivia.use_timer': 'Enable Question Timer',
    'editbreak.steps.text_trivia.question_duration': 'Question Duration (in seconds)',
    'editbreak.steps.text_trivia.question_duration.placeholder': 'Enter duration in seconds',
    'editbreak.steps.text_trivia.defaultAnswerBgColor': 'Default Button Bkgd Color',
    'editbreak.steps.text_trivia.defaultAnswerTextColor': 'Default Button Text Color',
    'editbreak.steps.text_trivia.question.reorder_toggle': 'Reorder questions',
    'editbreak.steps.text_trivia.question.header': 'Question {index}',
    'editbreak.steps.text_trivia.question.type': 'Question Type',
    'editbreak.steps.text_trivia.question.type.text': 'TEXT',
    'editbreak.steps.text_trivia.question.type.video': 'VIDEO',
    'editbreak.steps.text_trivia.question.question': 'Question {sectionIndex}',
    'editbreak.steps.text_trivia.question.use_default_image': 'Use Default Image?',
    'editbreak.steps.text_trivia.question.default_image': 'Default Image',
    'editbreak.steps.text_trivia.question.image': 'Question Image',
    'editbreak.steps.text_trivia.question.video_embed': 'Video Embed Code',
    'editbreak.steps.text_trivia.question.response_text': 'Question Response Text',
    'editbreak.steps.text_trivia.question.response_image': 'Question Response Image',
    'editbreak.steps.text_trivia.answer.header': 'Answer {index}',
    'editbreak.steps.text_trivia.answer.type': 'Answer Type',
    'editbreak.steps.text_trivia.answer.reorder_toggle': 'Reorder answers',
    'editbreak.steps.text_trivia.answer.type.text': 'TEXT',
    'editbreak.steps.text_trivia.answer.type.image': 'IMAGE',
    'editbreak.steps.text_trivia.answer.answer.placeholder': 'Enter answer',
    'editbreak.steps.text_trivia.answer.answer': 'Answer {sectionIndex}',
    'editbreak.steps.text_trivia.answer.image': 'Answer Image',
    'editbreak.steps.text_trivia.answer.correct': 'Answer Correct',
    'editbreak.steps.text_trivia.answer.edit_button_colors': 'Edit Button Colors?',
    'editbreak.steps.text_trivia.answer.bg_color': 'Answer Button Bkgd Color',
    'editbreak.steps.text_trivia.answer.bg_hover_color': 'Answer Button Bkgd Hover Color',
    'editbreak.steps.text_trivia.answer.text_color': 'Answer Button Text',
    'editbreak.steps.text_trivia.answer.text_hover_color': 'Answer Button Text Hover',
    'editbreak.steps.text_trivia.result.reorder_toggle': 'Reorder results',
    'editbreak.steps.text_trivia.result.header': 'Result {index}',
    'editbreak.steps.text_trivia.result.title': 'Result Title',
    'editbreak.steps.text_trivia.result.description': 'Result Description',
    'editbreak.steps.text_trivia.result.min_correct': 'Minimum Correct',
    'editbreak.steps.text_trivia.result.max_correct': 'Maximum Correct',
    'editbreak.steps.text_trivia.result.image': 'Result Image',
    'editbreak.steps.text_trivia.result.share_image': 'Result Social Image',

    'editbreak.steps.text_trivia.result.backgroundColor': 'Background Color',
    'editbreak.steps.text_trivia.result.backgroundImage': 'Background Image',


    'editbreak.steps.text_trivia.answer.user_tags.header': 'User Tag',
    'editbreak.steps.text_trivia.answer.user_tags.reorder_toggle': 'Reorder user tags',
    'editbreak.steps.text_trivia.answer.user_tags.tag_id': 'Tag',
    'editbreak.steps.text_trivia.answer.user_tags.point_weight': 'Point Weight',

    // UGC Photo
    'editbreak.steps.ugc_photo.heading': 'Step: UGC',
    'editbreak.steps.ugc_photo.heading.abv': 'Step: UGC',
    'editbreak.steps.ugc_photo.innerHeading': 'UGC: ',
    'editbreak.steps.ugc_photo.headline': 'Headline',
    'editbreak.steps.ugc_photo.intro_copy': 'Title Subhead',
    'editbreak.steps.ugc_photo.intro_copy.placeholder': 'Enter intro copy',
    'editbreak.steps.ugc_photo.example_image': 'Example Image',
    'editbreak.steps.ugc_photo.internal_name': 'Internal Name',
    'editbreak.steps.ugc_photo.start_button_text': 'Button Text',
    'editbreak.steps.ugc_photo.allow_photo_upload': 'Allow Photo Upload?',
    'editbreak.steps.ugc_photo.default_allow_drawing': 'Allow Drawing?',
    'editbreak.steps.ugc_photo.allow_text': 'Allow Text?',
    'editbreak.steps.ugc_photo.text_font': 'Text Font',
    'editbreak.steps.ugc_photo.text_color': 'Text Color',
    'editbreak.steps.ugc_photo.char_limit': 'Character Limit',
    'editbreak.steps.ugc_photo.text_line_height': 'Text Line Height',
    'editbreak.steps.ugc_photo.text_thickness': 'Text Thickness',
    'editbreak.steps.ugc_photo.text_thickness.thin': 'Thin',
    'editbreak.steps.ugc_photo.text_thickness.regular': 'Regular',
    'editbreak.steps.ugc_photo.text_thickness.medium': 'Medium',
    'editbreak.steps.ugc_photo.text_thickness.bold': 'Bold',
    'editbreak.steps.ugc_photo.stroke': 'Stroke?',
    'editbreak.steps.ugc_photo.text_position': 'Text Position',
    'editbreak.steps.ugc_photo.text_position.top_left': 'Top Left',
    'editbreak.steps.ugc_photo.text_position.left': 'Left',
    'editbreak.steps.ugc_photo.text_position.bottom_left': 'Bottom Left',
    'editbreak.steps.ugc_photo.text_position.top_right': 'Top Right',
    'editbreak.steps.ugc_photo.text_position.right': 'Right',
    'editbreak.steps.ugc_photo.text_position.bottom_right': 'Bottom Right',
    'editbreak.steps.ugc_photo.show_gallery': 'Show Gallery',
    'editbreak.steps.ugc_photo.instructions_header': 'Instructions',
    'editbreak.steps.ugc_photo.instruction.reorder_toggle': 'Reorder instructions',
    'editbreak.steps.ugc_photo.instruction.header': 'UGC: Instruction {sectionIndex}',
    'editbreak.steps.ugc_photo.instruction.headline': 'Instruction Headline',
    'editbreak.steps.ugc_photo.instruction.description': 'Instruction Description',
    'editbreak.steps.ugc_photo.instruction.label': 'Frame Label',
    'editbreak.steps.ugc_photo.instruction.button': 'Button Copy',
    'editbreak.steps.ugc_photo.instruction.legal': 'Legal Copy',
    'editbreak.steps.ugc_photo.frames_header': 'Frames',
    'editbreak.steps.ugc_photo.layers_headline': 'Headline',
    'editbreak.steps.ugc_photo.layers_desc': 'Intro',
    'editbreak.steps.ugc_photo.layers_button_text': 'Button Text',
    'editbreak.steps.ugc_photo.frame_bg_color': 'Frame Background Color',
    'editbreak.steps.ugc_photo.show_user_consent': 'Show Customized Consent Checkbox?',
    'editbreak.steps.ugc_photo.customized_consent_required': 'Customized Consent Requried?',
    'editbreak.steps.ugc_photo.consent_text': 'Consent Text',
    'editbreak.steps.ugc_photo.request_user_email': 'Request User Email?',
    'editbreak.steps.ugc_photo.user_email_required': 'User Email Required?',
    'editbreak.steps.ugc_photo.request_email_text': 'Request Email Text',
    'editbreak.steps.ugc_photo.frame.header': 'Frame {sectionIndex}',
    'editbreak.steps.ugc_photo.frames.reorder_toggle': 'Reorder frames',
    'editbreak.steps.ugc_photo.frame.image': 'Frame Image',
    'editbreak.steps.ugc_photo.frame.image2020': 'Frame Image - 750x750',
    'editbreak.steps.ugc_photo.frame.allow_photo_upload': 'Allow Photo Upload?',
    'editbreak.steps.ugc_photo.frame.allow_drawing': 'Allow Drawing?',
    'editbreak.steps.ugc_photo.frame.bg_color': 'Change Background Color?',
    'editbreak.steps.ugc_photo.frame.text_color': 'Change Text Color?',
    'editbreak.steps.ugc_photo.submission_share_header': 'Share',
    'editbreak.steps.ugc_photo.share_headline': 'Submission Share Headline',
    'editbreak.steps.ugc_photo.share_description': 'Submission Share Intro',
    'editbreak.steps.ugc_photo.gallery.header': 'Gallery',
    'editbreak.steps.ugc_photo.gallery.headline': 'Gallery Headline',
    'editbreak.steps.ugc_photo.gallery.description': 'Gallery Description',
    'editbreak.steps.ugc_photo.gallery.button_text': 'Gallery Button Text',
    'editbreak.steps.ugc_photo.gallery.show_sharing': 'Show Gallery Sharing',
    'editbreak.steps.ugc_photo.gallery.moderate': 'Moderate Gallery',


    // Dynamic content rules
    'editbreak.dynamic_content_rules.if': 'If',
    'editbreak.dynamic_content_rules.select_result': '-- Select result --',
    'editbreak.dynamic_content_rules.then': 'then',
    'editbreak.dynamic_content_rules.select_action': '-- Select action --',
    'editbreak.dynamic_content_rules.actions.show': 'Show',
    'editbreak.dynamic_content_rules.actions.hide': 'Hide',
    'editbreak.dynamic_content_rules.this_content': 'this content.',
    'editbreak.dynamic_content_rules.select_this_item': 'select this item.',

    // Video
    'editbreak.steps.video.heading': 'Step: Video',
    'editbreak.steps.video.heading.abv': 'Step: Video',
    'editbreak.steps.video.innerHeading': 'Video: ',
    'editbreak.steps.video.headline': 'Headline',
    'editbreak.steps.video.intro_copy': 'Title Subhead',
    'editbreak.steps.video.intro_copy.placeholder': 'Enter intro copy for video',
    'editbreak.steps.video.embed_code': 'Video Embed Code',
    'editbreak.steps.video.video_id': 'Video ID',

    'errors.dateRange.upperBeforeLower': "'To Date' must be after 'From Date'",
    'errors.format.permalink': 'Permalink may only contain letters and hyphens and not end in a hyphen.',
    'errors.NO_ACCESS_TO_FUNCTION': 'No permissions to edit this field',
    'errors.UNKNOWN': 'An unknown error occurred',
    'errors.PALETTE_ALREADY_EXISTS': 'Duplicate palette name',
    'errors.USER_NOT_FOUND': 'User cannot be found',
    'errors.PASSWORD_RESET_TO_MANY_ATTEMPTS' : 'Too many password reset attemps. Try again tomorrow.',
    'errors.ESCROW_BUDGET_INVALID': 'Month to copy has higher budget than entered. Uncheck "Copy Current Month" to proceed.',
    'errors.RETAILER_ITEM_ALREADY_EXISTS': 'An item already exists for that point value.',
    'errors.ESCROW_BALANCE_EXCEEDED': 'Escrow balance exceeded',
    'errors.HUB_NOT_FOUND': 'Hub not found',
    'errors.CUSTOM_LINE_OVERRIDE_EXISTS': 'A custom line override for that step already exists.',
    'errors.ACTION_LINK_ALREADY_EXISTS': 'You can\'t add the same tag to the same action.',

    'errors.validation.invalid_values': 'Invalid Values: {invalidValues}',
    'errors.validation.invalid_escrow_budget': 'Budget must be between {min} and {max} {currency}.',
    'errors.validation.password_mismatch': 'Passwords do not match.',
    'errors.validation.prize.drawInfo.chronological': 'Weekly draw dates must be in chronological order.',
    'errors.validation.prize.drawInfo.range': 'Weekly draw dates must be between the prize\'s start and end dates.',

    'errors.validation.ProperCurrencyValue': "Contains currency symbol but currency value doesn't match actual value.",
    'errors.validation.HTMLHasTextContent': "Field cannot be blank.",
    'errors.validation.NotNullOrBlank': "Field cannot be blank.",
    'errors.validation.Username': "This is not a valid username.",
    'errors.validation.NotNull': "Field must have a value.",
    'errors.validation.StepExists': "Chosen step does not exist on this Break's current platform",
    'errors.validation.CharacterLimit': 'Number of allowed characters in text has been exceeded',
    'errors.validation.NANDGate': 'This field cannot be true while the {otherField} field is true.',
    'errors.validation.MarkupTextLimit': 'Number of allowed characters in text has been exceeded',
    'errors.validation.HyperLinkFormat': "Url must start with either 'http://' or 'https://' and contain at least one character after.",
    'errors.validation.ValidIdForResource': 'Invalid id for resource.',
    'errors.validation.PermalinkFormat': 'Break URL Name should contain keywords, must be unique, cannot have spaces, and can only be written with lowercase letters separated by a hyphen.',
    'errors.validation.PermalinkNotInUse': 'That Break URL has been used already. Please choose another.',
    'errors.validation.NumberFormat': 'Value must be a number.',
    'errors.validation.IntegerFormat': 'Value must be an integer.',
    'errors.validation.InclusiveRange': 'Value must be between {min} and {max} (inclusive).',
    'errors.validation.OneCategoryPerBreak': 'A break can only be in one category.',
    'errors.validation.HexColorFormat': 'Color must be a valid hex color. Ex. #000000, #FFFFFF, #39FEC2.',
    'errors.validation.DuplicatePalette': 'Duplicate palette name',
    'errors.validation.EmailFormat' : 'Invalid email',

    // Loading Message
    'loading': "Loading",
    'loading.break': 'Loading break',
    'loading.prize': 'Loading prize',
    'loading.prizes.editorial': 'Loading editorial sweeps',
    'loading.prizes.sponsored': 'Loading sponsored prizes',
    'loading.winners.editorial': 'Loading sweeps winners',
    'loading.winners.sponsored': 'Loading sponsored winners',
    'loading.prizeHistory': 'Loading prize history',
    'loading.prizeWinners': 'Loading prize winners',
    'loading.entries': 'Loading prize entries',
    'loading.sonic': 'Loading at Sonic Speed',
    'loading.custom.events': 'Loading Events',

    // Platforms
    'platforms.basic': "Platforms",
    'platforms.MASTER': 'Master',
    'platforms.DAILYBREAK': 'Web',
    'platforms.EMBED': 'Embed',
    'platforms.DEMO': 'Demo',

    // Publish Modal
    'publish.modal.header.success': 'Publish Successful!',
    'publish.modal.header.error': 'Publish Failed!',
    'unpublish.modal.header.success': 'Unpublish Successful!',
    'unpublish.modal.header.error': 'Unpublish Failed!',
    'validate.modal.header.success': 'Validation Successful!',
    'validate.modal.header.error': 'Validation Failed!',

    // View All
    'editbreak.toggle.reorder_steps': 'Reorder steps',
    'editbreak.view_all.button.add': 'Add Step',
    'editbreak.view_all.button.delete': 'Delete Step',
    'editbreak.view_all.button.build': 'Build ',

    // Break Tag modal
    'breakTagModal.label': "Label",
    'breakTagModal.translations.en-US': "English US",
    'breakTagModal.translations.es-LA': "Spanish",
    'breakTagModal.translations.en-GB': "English UK",

    //Delete Break modal

    //Archive Break modal
    'archivebreak.header.archiveBreakQuestion': 'Are you sure you want to archive this break?',
    'archivebreak.button.archiveBreak': 'Archive this break',
    'archivebreak.button.donotarchive': 'Do not archive this break',

    // Step Types
    'step_types.article': 'Article',
    'step_types.beaker2': 'Beaker2',
    'step_types.checklist': 'Checklist',
    'step_types.complete': 'Complete',
    'step_types.custom_html': 'Custom HTML',
    'step_types.custom_json': 'Custom JSON',
    'step_types.drag_drop': 'Drag and Drop',
    'step_types.filtering': 'Filtering',
    'step_types.gallery': 'Gallery',
    'step_types.grocery': 'Grocery List',
    'step_types.lead_gen': 'Lead Gen',
    'step_types.listicle': 'Listicle',
    'step_types.media_upload': 'Media Upload',
    'step_types.memory_match': 'Memory Match',
    'step_types.personality_quiz': 'Personality Quiz',
    'step_types.pinterest': 'Pinterest',
    'step_types.poll': 'Poll',
    'step_types.puzzle': 'Puzzle',
    'step_types.receipt_verification': 'Receipt Verification',
    'step_types.referral': 'Referral',
    'step_types.review': 'Review',
    'step_types.spot_difference': 'Spot the Difference',
    'step_types.store_finder': 'Store Finder',
    'step_types.text_trivia': 'Text Trivia',
    'step_types.total': 'Total Social Shares',
    'step_types.total_social_shares': 'Total Social Shares',
    'step_types.ugc': 'UGC',
    'step_types.ugc_photo': 'UGC',
    'step_types.video': 'Video',

    // Tooltips
    'tooltips.break.general.edit_landing_page_fields': 'All multi-step breaks have landing pages that include a headline and intro copy. This copy can be customized. If “No,” the break title will be the headline, and the description will be the intro copy. ',

    //Poll Tooltip Headers
    'tooltips.break.poll.headline': 'Poll Headline',
    'tooltips.break.poll.intro': 'Poll Intro',
    'tooltips.break.poll.answerButtonBackgroundColor': 'Answer button bkgd color',
    'tooltips.break.poll.question': "Question",
    'tooltips.break.poll.questionImage': "Question image",
    'tooltips.break.poll.answer': "Answer",
    'tooltips.break.poll.editButtonColors': 'Edit button colors',
    'tooltips.break.poll.answerButtonTextColor': 'Answer button text',
    'tooltips.break.poll.questionResultText': 'Question result text',
    'tooltips.break.poll.questionResultImage': 'Question result image',
    'tooltips.break.poll.questionGraphQuestion': 'Edit result graph colors?',
    'tooltips.break.poll.questionGraphSuccessColor': 'User Selection Bar Color',
    'tooltips.break.poll.questionGraphFailColor': 'Not Selected Bar Color',

    //Breaks Steps Tooltip Headers
    'tooltips.break.breaks_steps.relatedBreak': 'Related break',
    'tooltips.break.breaks_steps.fbCommentQuestion': 'Facebook comment question',
    'tooltips.break.breaks_steps.showNextButton': 'Show Next button?',
    'tooltips.break.breaks_steps.nextButtonText': 'Button text',
    'tooltips.break.breaks_steps.nextButtonLinkType': 'Link type',
    'tooltips.break.breaks_steps.showSkipLink': 'Show Skip link?',
    'tooltips.break.breaks_steps.skipLinkText': 'Button text',
    'tooltips.break.breaks_steps.skipLinkLinkType': 'Link type',
    'tooltips.break.breaks_steps.sharingOn': 'Sharing On?',

    // Image Upload Tooltips
    'tooltips.image.upload.filename': 'The original name of the image or gif uploaded, pulled directly from your computer.',
    'tooltips.image.upload.name': 'The title of the image or gif, edited by user to maximize search-ability. Campaign images should follow: brand-campaign-retailer-imagetype',
    'tooltips.image.upload.source': 'Site, photographer, or organization the image is from. This will appear under the image on each pasge the image appears. The "www" and "http://" should be removed.',
    'tooltips.image.upload.altAttribute': 'Detailed description of what is seen in the image. This description will be used by readers using accessibility tools.',
    'tooltips.image.upload.link': 'The hyperlink the image was taken from.',

    // Create Step Modal
    "add_step.ArticleStep": "Article",
    "add_step.ChecklistStep": "Checklist",
    "add_step.grocerycheckliststep": "Grocery Checklist",
    "add_step.CompleteStep": "Complete",
    "add_step.CustomHtmlStep": "Custom HTML",
    "add_step.CustomJsonStep": "Custom JSON",
    "add_step.DragAndDropStep": "Drag and Drop",
    "add_step.FilteringStep": "Filtering",
    "add_step.GalleryStep": "Gallery",
    "add_step.GroceryStep": "Grocery List",
    "add_step.LeadGenStep": "Lead Gen",
    "add_step.ListicleStep": "Listicle",
    "add_step.MediaUploadStep": "Media Upload",
    "add_step.MemoryMatchStep": "Memory Match",
    "add_step.PersonalityQuizStep": "Personality Quiz",
    "add_step.PhotoStep": "UGC",
    "add_step.PinterestStep": "Pinterest",
    "add_step.PollStep": "Poll",
    "add_step.PuzzleStep": "Puzzle",
    "add_step.ReceiptVerificationStep": "Receipt Verification",
    "add_step.ReferralStep": "Referral",
    "add_step.ReviewStep": "Review",
    "add_step.SpotTheDifferenceStep": "Spot the Difference",
    "add_step.StoreFinderStep": "Store Finder",
    "add_step.TextTriviaStep": "Text Trivia",
    "add_step.VideoStep": "Video",
    "add_step.Beaker2Step": "Beaker2",

    // Filters
    // these site filters need to be in dailybreak.Filter
    'filter.break_site_dailybreak': 'Dailybreak',
    'filter.break_site_bestdailyrecipes': 'Best Daily Recipes',
    'filter.break_site_fifaunilever': 'Unilever World Cup 26',
    'filter.break_site_dailybreak_uk': 'Dailybreak UK',
    'filter.break_site_el_dailybreak': 'El Dailybreak',
    'filter.break_type_editorial': 'Editorial',
    'filter.break_type_sponsored': 'Sponsored',
    'filter.created_today': 'Breaks created in last 24 Hours',
    'filter.created_last_7_days': 'Breaks created in last 7 days',
    'filter.created_last_30_days': 'Breaks created in last 30 days',
    'filter.image_type_original': 'Original',
    'filter.my_resources': 'My Breaks',
    'filter.publish_status_archived': 'Archived',
    'filter.publish_status_draft': 'Draft',
    'filter.publish_status_live': 'Live',
    'filter.publish_status_ready': 'Ready',
    'filter.step_article': 'Article',
    'filter.step_checklist': 'Checklist',
    'filter.step_complete': 'Complete',
    'filter.step_custom_json': 'Custom JSON',
    'filter.step_custom_html': 'Custom HTML',
    'filter.step_drag_drop': 'Drag and Drop',
    'filter.step_filtering': 'Filtering',
    'filter.step_gallery': 'Gallery with Voting',
    'filter.step_grocery': 'Grocery List',
    'filter.step_leadgen': 'Lead Gen',
    'filter.step_listicle': 'Listicle',
    'filter.step_mediaupload': 'Media Upload',
    'filter.step_memory_match': 'Memory Match',
    'filter.step_personality_quiz': 'Personality Quiz',
    'filter.step_pinterest': 'Pinterest',
    'filter.step_poll': 'Poll',
    'filter.step_puzzle': 'Puzzle',
    'filter.step_receipt_campaign': 'Receipt Verification',
    'filter.step_referral': 'Referral',
    'filter.step_review': 'Review',
    'filter.step_spot_difference': 'Spot the Difference',
    'filter.step_store_finder': 'Store Finder',
    'filter.step_text_trivia': 'Text Trivia',
    'filter.step_ugc': 'UGC',
    'filter.step_video': 'Video',
    'filter.clearAll': 'Clear All',
    'filter.notFound': 'Filter not found.',
    'filter.prize_need_winners': 'Needs Winners',
    'filter.prize_assigned_winners': 'Assigned Winners',
    'filter.prize_site_dailybreak': 'Dailybreak',
    'filter.prize_site_el_dailybreak': 'El Dailybreak',
    'filter.prize_site_dailybreak_uk': 'Dailybreak UK',
    'filter.prize_ended_today': 'Ended in the last day',
    'filter.prize_ended_last_7_days': 'Ended in the last 7 days',
    'filter.prize_ended_last_30_days': 'Ended in the last 30 days',

    //Break List

    'breakList.status_LIVE': 'Live',
    'breakList.status_READY': 'Ready',
    'breakList.status_ARCHIVED': 'Archived',
    'breakList.status_MODIFIED': 'Modified',
    'breakList.status_DRAFT': 'Draft',
    'breakList.type_editorial': 'Editorial',
    'breakList.type_sponsored': 'Sponsored',

    'breakList.state_asterisk':  'This break has been modified but latest \n changes have not yet been published.',

    'images.picker.action.remove': 'Remove',
    'images.picker.action.editInfo': 'Edit Info',
    'images.picker.action.editImage': 'Edit Image',
    'images.picker.status.creatingImage': 'Creating Image',

    'images.edit.filename': "Filename",
    'images.edit.name': "Image Name",
    'images.edit.source': "Image Source",
    'images.edit.altAttribute': "Alt Tag / Image Description for Accessibility",
    'images.edit.link': "Source Hyperlink",

    'images.imageType.original': "Original",
    "images.imageType.winnerUser": "Winner User",
    "images.imageType.sweepsPrize": "Sweeps Prize",
    "images.imageType.cardTrending": "Card Trending",
    "images.imageType.featured": "Featured",
    "images.imageType.socialShare": "Social Share",
    "images.imageType.socialSharePinterest": "Social Share Pinterest",
    "images.imageType.clientLogo": "Client Logo",
    "images.imageType.mapImage": "Map Image",
    "images.imageType.backgroundWrapper": "Background Wrapper",
    "images.imageType.personalityQuestion": "Personality Question",
    "images.imageType.personalityAnswer": "Personality Answer",
    "images.imageType.personalityResult": "Personality Result",
    "images.imageType.personalityBranded": "Personality Branded",
    "images.imageType.shoppingListVertical": "Shopping List Vertical",
    "images.imageType.shoppingListHorizontal": "Shopping List Horizontal",
    "images.imageType.stepHeaderImage": "Step Header",
    "images.imageType.facebookComment": "Facebook Comment",
    "images.imageType.referralReward": "Referral/Reward",
    "images.imageType.leadGen": "LeadGen",
    "images.imageType.complete": "Complete",
    "images.imageType.listicle": "Listicle (Old)",
    "images.imageType.listicleHorizontal": "Listicle Horizontal",
    "images.imageType.listicleVertical": "Listicle Vertical",
    "images.imageType.listicleHeader": "Listicle Header",
    "images.imageType.listicleFlexibleHeight": "Listicle Flexible Height",
    "images.imageType.triviaQuestion": "Trivia Question",
    "images.imageType.triviaAnswer": "Trivia Answer",
    "images.imageType.triviaResult": "Trivia Result",
    "images.imageType.triviaResultShare": "Trivia Result Share",
    "images.imageType.pollQuestion": "Poll Question",
    "images.imageType.pollAnswer": "Poll Answer",
    "images.imageType.pollAnswerImageOptions": "Poll Answer Image Options",
    "images.imageType.memoryMatchCard": "Memory Match Card",
    "images.imageType.spotDif": "Spot the Difference",
    "images.imageType.dragDrop": "Drag and Drop",
    "images.imageType.dragDropPuzzleExample": "Puzzle Example Image",
    "images.imageType.dragDropCardImage": "Drag and Drop Card Image",
    "images.imageType.ugcNoteCardExample": "UGC Note Card Example",
    "images.imageType.ugcNoteCardTemplate": "UGC Note Card Template",
    "images.imageType.ugcFaceInHoleExample": "UGC Face In Hole Example",
    "images.imageType.ugcFaceInHoleOption": "UGC Face In Hole Option",
    "images.imageType.ugcPhotoUploadExample": "UGC Photo Upload Example",
    "images.imageType.ugcPhotoUploadOption": "UGC Photo Upload Option",
    "images.imageType.checkListHalf": "Checklist Half",
    "images.imageType.checkListFull": "Checklist Full",
    "images.imageType.receiptHeader": "Receipt Header",

    // Prize List
    'prizeList.nav.tab.editorialSweeps': 'Editorial Sweeps',
    'prizeList.nav.tab.sponsoredPrizing': 'Sponsored Prizing',

    'prizeList.dateRange.fromDate': 'From Date',
    'prizeList.dateRange.toDate': 'To Date',

    'prizeList.column.header.title': 'Prize',
    'prizeList.column.header.status': 'Status',
    'prizeList.column.header.points': 'Points',
    'prizeList.column.header.breakId': 'Break ID',
    'prizeList.column.content.breakId.multiple': 'Multiple',
    'prizeList.column.header.entries': 'Entries',
    'prizeList.column.header.startDate': 'Start Date',
    'prizeList.column.header.endDate': 'End Date',
    'prizeList.column.header.winner': 'Winner',
    'prizeList.column.header.actions': 'Actions',

    'prizeList.column.tooltip.noTitle': 'No title',
    'prizeList.column.content.winner.multiple': 'Multiple',

    'prizeList.column.status.enum.SCHEDULED': 'Scheduled',
    'prizeList.column.status.enum.ACTIVE': 'Active',
    'prizeList.column.status.enum.UNVERIFIED': 'Unverified',
    'prizeList.column.status.enum.COMPLETE': 'Complete',
    'prizeList.column.status.enum.UNSCHEDULED': 'Unscheduled',
    'prizeList.column.status.enum.UNAWARDED': 'Unawarded',
    'prizeList.column.status.enum.UNCLAIMED': 'Unclaimed',
    'prizeList.column.status.enum.CLAIMED': 'Claimed',
    'prizeList.column.status.enum.UNKNOWN': 'Unknown',
    'prizeList.column.status.enum.PENDING_AWARDING': 'To Be Awarded',
    'prizeList.column.status.enum.PENDING_CLAIM': 'Not Claimed',

    // Multiple Winners page
    'multipleWinners.title': 'Multiple Winners',
    'multipleWinners.column.winner': 'Winner',
    'multipleWinners.column.email': 'Email',
    'multipleWinners.column.phone': 'Phone',
    'multipleWinners.column.address': 'Address',
    'multipleWinners.column.prizeId': 'Prize ID',
    'multipleWinners.column.winDate': 'Win Date',
    'multipleWinners.column.forfeitDate': 'Forfeit Date',

    // Edit Prize accordion
    'editprize.edit.heading': 'Prizing',
    'editprize.summary.heading.editorial': 'Editorial Sweeps Prize',
    'editprize.summary.heading.sponsored': 'Sponsored Break Prize',
    'editprize.summary.link.dashboard': 'Back to Prizing Dashboard',
    'editprize.edit.title.label': 'Prize Title',
    'editprize.edit.autoSendEmail.label': "Auto Send e-mail/claim form?",
    'editprize.edit.title.placeholder': 'Enter prize title',
    'editprize.edit.description.label': 'Prize Description',
    'editprize.edit.showWinnersOnWinnersPage.label': "Show Winners on Winners page?",
    'editprize.edit.imageId.label': 'Prize Image',
    'editprize.edit.orderLink.label': 'Link to Order Prize',
    'editprize.edit.numToAward.label': 'Number of Winners',
    'editprize.edit.costToEnter.label': 'Points to Enter',
    'editprize.edit.itemType.label': 'Prize Type',
    'editprize.edit.itemType.options.points': 'Points',
    'editprize.edit.itemType.options.virtualCard': 'Virtual gift card',
    'editprize.edit.itemType.options.physicalCard': 'Physical gift card',
    'editprize.edit.itemType.options.other': 'Other product',
    'editprize.edit.value.label': 'Prize Value',
    'editprize.edit.value.extraContent': 'W9 and Affidavit required',
    'editprize.edit.passThroughCost.label': 'Pass Through Cost',
    'editprize.edit.passThroughAmount.label': 'Pass Through Amount',
    'editprize.edit.redrawWinners.label': 'Redraw Winners?',
    'editprize.edit.startTime.label': 'Prize Start Date and Time',
    'editprize.edit.startTime.placeholder': 'Select date and time',
    'editprize.edit.endTime.label': 'Prize End Date and Time',
    'editprize.edit.endTime.placeholder': 'Select date and time',
    'editprize.edit.weeklyWinners.label': 'Weekly Winners',
    'editprize.edit.prizeDrawInfo.label': 'Week {num} Draw Date',
    'editprize.edit.winnerSelectionDate.label': 'Winner Selection Date and Time',
    'editprize.edit.winnerSelectionDate.placeholder': 'Select date and time',
    'editprize.edit.restrictions.label': 'Restrictions',
    'editprize.edit.notes.label': 'Additional Notes',
    'editprize.publish.error.costToEnter.NotWithinRequiredRange': 'Points to Enter must be in range 1-500',
    'editprize.publish.error.costToEnter.CannotBeEmpty': 'Points to Enter required',
    'editprize.publish.error.description.CannotBeEmpty': 'Prize Description required',
    'editprize.publish.error.imageId.CannotBeEmpty': 'Prize Image is required',
    'editprize.publish.error.startTime.CannotBeEmpty': 'Start Time required',
    'editprize.publish.error.endTime.CannotBeEmpty': 'End Time required',
    'editprize.publish.error.drawInfo.CannotBeEmpty': 'Weekly Draw Dates required',
    'editprize.publish.error.winnerSelectionDate.CannotBeEmpty': 'Winner Selection Date required',
    'errors.validation.startTime.UnacceptableDateValue': 'Start Time must be before End Time',
    'errors.validation.endTime.UnacceptableDateValue': 'End Time must be after Start Time',

    // Winners List
    'winnersList.column.header.winner': 'Winner',
    'winnersList.column.subrow.winner.sponsored': 'W9 and Affidavit',
    'winnersList.column.header.prize': 'Prize',
    'winnersList.column.header.breakId': 'Break ID',
    'winnersList.column.header.entries': 'Entries',
    'winnersList.column.header.startDate': 'Start Date',
    'winnersList.column.header.endDate': 'End Date',
    'winnersList.column.header.status': 'Status',
    'winnersList.column.header.claimed': 'Claimed',
    'winnersList.column.header.ordered': 'Ordered',
    'winnersList.column.header.fulfillmentNotes': 'Notes',
    'winnersList.column.header.notified': 'Notified',
    'winnersList.column.header.renotified': 'Renotified',
    'winnersList.column.header.forfeited': 'Forfeited',
    'winnersList.column.header.prizeLink': 'Prize Link',
    'winnersList.column.header.editStory': 'Edit Story',
    'winnersList.column.header.makeFeatured': 'Make Featured',

    'winnersList.error.makeFeatured.en-US': 'Cannot have more than four featured stories on Dailybreak (US).',
    'winnersList.error.makeFeatured.en-GB': 'Cannot have more than two featured stories on Dailybreak UK.',

    'winnersList.error.publishFeatured.en-US': 'Unable to publish featured winners to Dailybreak (US).',
    'winnersList.error.publishFeatured.es-LA': 'Unable to publish featured winners to El Dailybreak.',
    'winnersList.error.publishFeatured.en-GB': 'Unable to publish featured winners to Dailybreak UK.',

    'winnersList.nav.tab.sweepsWinners': 'Sweeps Winners',
    'winnersList.nav.tab.sponsoredWinners': 'Sponsored Winners',

    // editorial
    'winnersList.column.status.enum.NOTIFIED': 'Unclaimed',
    'winnersList.column.status.enum.PREORDERED': 'Claimed',
    'winnersList.column.status.enum.ORDERED': 'Complete',
    'winnersList.column.status.enum.FORFEITED': 'Forfeited',

    // sponsored
    'winnersList.column.status.enum.SCHEDULED': 'Scheduled',
    'winnersList.column.status.enum.ACTIVE': 'Active',
    'winnersList.column.status.enum.UNAWARDED': 'Unawarded',
    'winnersList.column.status.enum.AWARDED': 'Awarded',
    'winnersList.column.status.enum.UNCLAIMED': 'Unclaimed',
    'winnersList.column.status.enum.CLAIMED': 'Claimed',

    'winnersList.modal.editStory.header': 'Edit User Story',
    'winnersList.modal.editStory.error': 'Could not save user story edits.',
    'winnersList.modal.notes.header': 'Notes',
    'winnersList.modal.notes.error': 'Could not save notes',

    'entriesList.column.header.entrant': 'Entrant',
    'entriesList.column.header.email': 'Email',
    'entriesList.column.header.entryDate': 'Entry Date',
    'entriesList.column.header.winDate': 'Win Date',
    'entriesList.column.header.forfeitDate': 'Forfeit Date',
    'entriesList.link.goBack': '< Go Back',
    'entriesList.content.noTitle': 'No title',
    'entriesList.label.prize': 'Prize: ',
    'entriesList.label.breakId': 'Break ID: ',
    'entriesList.label.winnersRequired': '{numToAward} Winner(s) Required',
    'entriesList.label.endDate': 'End Date: {endDate}',
    'entriesList.label.autoAwardDate': 'Auto-Award Date: {autoAwardDate}',
    'entriesList.button.selectWinners': 'Select Winner(s)',
    'entriesList.button.manualEntry': 'Manual Entry',

    'prizes.manual.entry.breakId': 'Break',
    'prizes.manual.entry.title': 'Manual Prize Entry',
    'prizes.manual.entry.cancel': 'Cancel',
    'prizes.manual.entry.submit': 'Submit',
    'prizes.manual.entry.firstName': 'First Name',
    'prizes.manual.entry.lastName': 'Last Name',
    'prizes.manual.entry.email': 'Email',
    'prizes.manual.entry.address': 'Address',
    'prizes.manual.entry.address2': 'Address Line 2',
    'prizes.manual.entry.city': 'City',
    'prizes.manual.entry.state': 'State',
    'prizes.manual.entry.zip': 'Zip',
    'prizes.manual.entry.dateOfBirth': 'Date of Birth',
    'prizes.manual.entry.phone': 'Phone',

    // UGC Moderation
    'ugc.platform_filter.button': 'Update View',

    // Break Reporting
    'kpi.share.total.FB_SHARE': 'Share with Friends (Facebook)',
    'kpi.share.total.EMAIL_SHARE': 'Share with Friends (Email)',
    'kpi.share.total.PINTEREST_SHARE': 'Share with Friends (Pinterest)',
    'kpi.share.total.PRINTED': 'Printed',
    'kpi.share.total.TWITTER_SHARE': 'Share with Friends (Twitter)',

    'kpi.total.excluded': ' (Excluded from Total)',

    'kpi.topline.filtering.dropdown.clicked': 'Filters Selected',

    // KPIs Added 12/12/18 To not use hardcoded values in API
    'kpi.FILTERING_RESULT_CLICK': 'Filtering Result Click',
    'kpi.FILTERING_DROPDOWN_CLICK': 'Filtering Dropdown Click',
    'kpi.LEAD_GEN_SUBMISSION': 'Lead Gen Submissions',
    'kpi.PERSONALITY_QUIZ_RESULT': 'Personality Quiz Results',
    'kpi.POLL_QUESTIONS_ANSWERED': 'Poll Questions Answered',
    'kpi.RECEIPTS_APPROVED': 'Approved Receipts',
    'kpi.REFERRAL_CLICK': 'Referral Clicks',
    'kpi.REQUESTED_EMAIL_REMINDER':'Requested Email Reminder',
    'kpi.TOTAL_FB_SHARE': 'Share with Friends (Facebook)',
    'kpi.TOTAL_TWITTER_SHARE': 'Share with Friends (Twitter)',
    'kpi.TOTAL_PINTEREST_SHARE': 'Share with Friends (Pinterest)',
    'kpi.TOTAL_EMAIL_SHARE': 'Share with Friends (Email)',
    'kpi.TOTAL_PRINTED': 'Printed (Excluded from Total)',
    'kpi.TRIVIA_QUESTIONS_ANSWERED': 'Trivia Questions Answered',
    'kpi.UGC_SUBMISSION': 'UGC Submissions',
    'kpi.VIDEO_VIEW':'Video Views',
    'kpi.MENU_CONTENT_CLICK': "Menu Item Clicks",
    'kpi.menu_content_name_row': "Menu: {menuName}",

    // Add to Calendar kpis

    'kpi.ADD_TO_CAL': "Add to Calendar",
    'kpi.ADD_TO_CAL_YAHOO': "Yahoo",
    'kpi.ADD_TO_CAL_GOOGLE': "Google",
    'kpi.ADD_TO_CAL_ICAL': "ICal",
    'kpi.ADD_TO_CAL_OUTLOOK': "Outlook",

    // User Management
    'userManagement.title': 'User Management',

    'userManagement.usersList.header': 'Users',
    'userManagement.usersList.email': 'Email',
    'userManagement.usersList.uid': 'User ID',
    'userManagement.usersList.username': 'Username',
    'userManagement.usersList.site': 'Site',
    'userManagement.usersList.userGroup': 'User Group',
    'userManagement.usersList.firstName': 'First Name',
    'userManagement.usersList.lastName': 'Last Name',
    'userManagement.usersList.verifiedEmail': 'Verified Email',

    'userManagement.createUser.title': 'Create new user',
    'userManagement.createUser.group': 'User group',
    'userManagement.createUser.email': 'Email',
    'userManagement.createUser.firstName': 'First name',
    'userManagement.createUser.lastName': 'Last name',
    'userManagement.createUser.username': 'Username',
    'userManagement.createUser.password': 'Password',
    'userManagement.createUser.passwordConfirmation': 'Confirm password',
    'userManagement.createUser.cancel': 'Cancel',
    'userManagement.createUser.submit': 'Submit',

    'userManagement.searchPanel.header': 'Search',
    'userManagement.searchPanel.email': 'Email',
    'userManagement.searchPanel.uid': 'User ID',
    'userManagement.searchPanel.username': 'Username',
    'userManagement.searchPanel.firstName': 'First Name',
    'userManagement.searchPanel.lastName': 'Last Name',
    'userManagement.searchPanel.commentId': 'Facebook Comment ID',
    'userManagement.searchPanel.adminsOnly': 'Admins Only',
    'userManagement.searchPanel.siteId': 'Site',
    'userManagement.searchPanel.siteId.text': 'Select Site',
    'userManagement.searchPanel.submit': 'Search',
    'userManagement.searchPanel.clear': 'Clear',

    'userManagement.userDetail.nav.overview': 'Overview',
    'userManagement.userDetail.nav.challenges': 'Breaks',
    'userManagement.userDetail.nav.raffles': 'Sweeps',
    'userManagement.userDetail.nav.store': 'Store',
    'userManagement.userDetail.nav.points': 'Points',
    'userManagement.userDetail.nav.badges': 'Badges',

    'userManagement.userDetail.button.close': 'Close',
    'userManagement.userDetail.actions.button': 'Actions',
    'userManagement.userDetail.actions.awardPoints': 'Award points',
    'userManagement.userDetail.actions.awardSpins': 'Award spins',
    'userManagement.userDetail.actions.awardDays': 'Award consecutive days',
    'userManagement.userDetail.actions.changeEmail': 'Change email',
    'userManagement.userDetail.actions.changePassword': 'Change password',
    'userManagement.userDetail.actions.revokeAmountOfPoints': 'Revoke points',
    'userManagement.userDetail.actions.repairProfile': 'Repair profile',
    'userManagement.userDetail.actions.deleteUser': 'Deactivate user',
    'userManagement.userDetail.actions.undeleteUser': 'Reactivate user',
    'userManagement.userDetail.actions.deleteUserData': 'Delete user data',

    'userManagement.deleteUserData.cancel': "Cancel",
    'userManagement.deleteUserData.confirm': "Confirm",
    'userManagement.deleteUserData.header': "Confirm user data deletion",
    'userManagement.deleteUserData.confirmMessage': "Are you sure you want to PERMANENTLY delete ALL of this user's data?",

    'userManagement.userDetail.modals.awardPoints.header': 'Award points to {email}',
    'userManagement.userDetail.modals.awardPoints.amount': 'Point amount',
    'userManagement.userDetail.modals.awardPoints.reason': 'Reason',
    'userManagement.userDetail.modals.awardPoints.cancel': 'Cancel',
    'userManagement.userDetail.modals.awardPoints.submit': 'Add Points',
    'userManagement.userDetail.modals.awardPoints.errors.missing.field.amount': "'Point amount' required.",
    'userManagement.userDetail.modals.awardPoints.errors.missing.field.reason': "'Reason' required.",

    'userManagement.userDetail.modals.awardSpins.header': 'Award spins to {email}',
    'userManagement.userDetail.modals.awardSpins.amount': 'Total spins',
    'userManagement.userDetail.modals.awardSpins.cancel': 'Cancel',
    'userManagement.userDetail.modals.awardSpins.submit': 'Add Spins',

    'userManagement.userDetail.modals.awardDays.header': 'Award consecutive days to {email}',
    'userManagement.userDetail.modals.awardDays.amount': 'Total consecutive days',
    'userManagement.userDetail.modals.awardDays.cancel': 'Cancel',
    'userManagement.userDetail.modals.awardDays.submit': 'Add Consecutive Days',

    'userManagement.userDetail.modals.changePassword.header': 'Change password for {email}',
    'userManagement.userDetail.modals.changePassword.newPassword': 'New password',
    'userManagement.userDetail.modals.changePassword.newPasswordConfirm': 'Confirm new password',
    'userManagement.userDetail.modals.changePassword.cancel': 'Cancel',
    'userManagement.userDetail.modals.changePassword.submit': 'Change Password',

    'userManagement.userDetail.modals.repairProfile.header': 'Repair profile for {email}',
    'userManagement.userDetail.modals.repairProfile.message': 'Are you sure you want to repair the user profile for {email}?',
    'userManagement.userDetail.modals.repairProfile.cancel': 'Cancel',
    'userManagement.userDetail.modals.repairProfile.submit': 'Fix Profile',

    'userManagement.userDetail.modals.revokeAmountOfPoints.header': 'Revoke points from {email}',
    'userManagement.userDetail.modals.revokeAmountOfPoints.amount': 'Point amount',
    'userManagement.userDetail.modals.revokeAmountOfPoints.reason': 'Reason',
    'userManagement.userDetail.modals.revokeAmountOfPoints.cancel': 'Cancel',
    'userManagement.userDetail.modals.revokeAmountOfPoints.submit': 'Revoke Points',

    'userManagement.userDetail.modals.revokePoints.header': 'Revoke points for {email}',
    'userManagement.userDetail.modals.revokePoints.message': 'Are you sure you want to revoke {amount} point(s) from {email}?',
    'userManagement.userDetail.modals.revokePoints.cancel': 'Cancel',
    'userManagement.userDetail.modals.revokePoints.submit': 'Revoke Points',

    'userManagement.userDetail.panes.overview.group': 'Group',
    'userManagement.userDetail.panes.overview.createdOn': 'Member Since',
    'userManagement.userDetail.panes.overview.createdOn.deleted': 'Deactivated',
    'userManagement.userDetail.panes.overview.email': 'Email',
    'userManagement.userDetail.panes.overview.email.subscribed': 'Subscribed',
    'userManagement.userDetail.panes.overview.email.unsubscribed': 'Unsubscribed',
    'userManagement.userDetail.panes.overview.firstName': 'First Name',
    'userManagement.userDetail.panes.overview.lastName': 'Last Name',
    'userManagement.userDetail.panes.overview.age': 'Age',
    'userManagement.userDetail.panes.overview.gender': 'Gender',
    'userManagement.userDetail.panes.overview.birthday': 'Birthdate',
    'userManagement.userDetail.panes.overview.city': 'City',
    'userManagement.userDetail.panes.overview.state': 'State',
    'userManagement.userDetail.panes.overview.zipCode': 'Zip',
    'userManagement.userDetail.panes.overview.lastLogin': 'Last Login',
    'userManagement.userDetail.panes.overview.emailPref': 'Email Preference',
    'userManagement.userDetail.panes.overview.level': 'Current Level',
    'userManagement.userDetail.panes.overview.lastEmailUpdate': 'Last Email Update',
    'userManagement.userDetail.panes.overview.lastEmailUpdate.none': 'No record',
    'userManagement.userDetail.panes.overview.deleted': 'Deactivated',
    'userManagement.userDetail.panes.overview.regIpAddress': 'IP Address',
    'userManagement.userDetail.panes.overview.ajaxError': 'Request failed for user profile overview.',

    'userManagement.userDetail.panes.challenges.totalStarts': 'Challenge Starts',
    'userManagement.userDetail.panes.challenges.totalCompletes': 'Challenge Completes',
    'userManagement.userDetail.panes.challenges.totalWon': 'Challenge Wins',
    'userManagement.userDetail.panes.challenges.cid': 'ID',
    'userManagement.userDetail.panes.challenges.title': 'Title',
    'userManagement.userDetail.panes.challenges.dateStarted': 'Started',
    'userManagement.userDetail.panes.challenges.dateCompleted': 'Completed',
    'userManagement.userDetail.panes.challenges.status': 'Status',
    'userManagement.userDetail.panes.challenges.status.winner': 'Winner',
    'userManagement.userDetail.panes.challenges.status.incomplete': 'Incomplete',
    'userManagement.userDetail.panes.challenges.ajaxError': 'Request failed for user\'s break history.',

    'userManagement.userDetail.panes.raffles.raffleId': 'Raffle ID',
    'userManagement.userDetail.panes.raffles.prizeTitle': 'Prize',
    'userManagement.userDetail.panes.raffles.dateCreated': 'Date',
    'userManagement.userDetail.panes.raffles.winner': 'Winner',
    'userManagement.userDetail.panes.raffles.empty': 'User has not entered any sweeps',
    'userManagement.userDetail.panes.raffles.ajaxError': 'Request failed for user\'s sweeps entries.',

    'userManagement.userDetail.panes.store.dateCreated': 'Date',
    'userManagement.userDetail.panes.store.offerPartner': 'Partner',
    'userManagement.userDetail.panes.store.offerName': 'Offer',
    'userManagement.userDetail.panes.store.offerType': 'Type',
    'userManagement.userDetail.panes.store.cost': 'Cost',
    'userManagement.userDetail.panes.store.refunded': 'Refunded',
    'userManagement.userDetail.panes.store.orderId': 'Order ID',
    'userManagement.userDetail.panes.store.offerId': 'Offer ID',
    'userManagement.userDetail.panes.store.empty': 'User has not purchased any items from the store',
    'userManagement.userDetail.panes.store.ajaxError': 'Request failed for user\'s store purchase history.',

    'userManagement.userDetail.panes.points.points': 'Points',
    'userManagement.userDetail.panes.points.lifetimePoints': 'All-Time Points',
    'userManagement.userDetail.panes.points.id': 'ID',
    'userManagement.userDetail.panes.points.amount': 'Amount',
    'userManagement.userDetail.panes.points.amountBonus': 'Bonus',
    'userManagement.userDetail.panes.points.amountTotal': 'Total',
    'userManagement.userDetail.panes.points.userLevel': 'Level',
    'userManagement.userDetail.panes.points.reason': 'Reason',
    'userManagement.userDetail.panes.points.transactionType': 'Transaction Type',
    'userManagement.userDetail.panes.points.dateCreated': 'Date',
    'userManagement.userDetail.panes.points.cancel': 'Cancel',
    'userManagement.userDetail.panes.points.ajaxError': 'Request failed for user\'s points history.',
    'userManagement.userDetail.panes.points.lifetimePointsError': 'Request failed for user\'s points totals.',

    'userManagement.userDetail.panes.badges.points': 'Points',
    'userManagement.userDetail.panes.badges.badge.COMMENTED_10.title': 'Emcee',
    'userManagement.userDetail.panes.badges.badge.COMMENTED_10.desc.locked': 'Post a comment in 10 different breaks',
    'userManagement.userDetail.panes.badges.badge.COMMENTED_10.desc.unlocked': 'Posted 10 comments',
    'userManagement.userDetail.panes.badges.badge.COMMENTED_75.title': 'Socialite',
    'userManagement.userDetail.panes.badges.badge.COMMENTED_75.desc.locked': 'Post a comment in 75 different breaks',
    'userManagement.userDetail.panes.badges.badge.COMMENTED_75.desc.unlocked': 'Posted 75 comments',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_10_CHALLENGES.title': 'Newcomer',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_10_CHALLENGES.desc.locked': 'Complete 10 breaks',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_10_CHALLENGES.desc.unlocked': 'Completed 10 breaks',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_30_CHALLENGES.title': 'Rising Star',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_30_CHALLENGES.desc.locked': 'Complete 30 breaks',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_30_CHALLENGES.desc.unlocked': 'Completed 30 breaks',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_75_CHALLENGES.title': 'Celeb',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_75_CHALLENGES.desc.locked': 'Complete 50 breaks',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_75_CHALLENGES.desc.unlocked': 'Completed 50 breaks',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_175_CHALLENGES.title': 'Rockstar',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_175_CHALLENGES.desc.locked': 'Complete 175 breaks',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_175_CHALLENGES.desc.unlocked': 'Completed 175 breaks',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_500_CHALLENGES.title': 'Superstar',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_500_CHALLENGES.desc.locked': 'Complete 500 breaks',
    'userManagement.userDetail.panes.badges.badge.COMPLETED_500_CHALLENGES.desc.unlocked': 'Completed 500 breaks',
    'userManagement.userDetail.panes.badges.badge.EMAIL_VERIFICATION.title': 'Verified User',
    'userManagement.userDetail.panes.badges.badge.EMAIL_VERIFICATION.desc.locked': 'Verify email',
    'userManagement.userDetail.panes.badges.badge.EMAIL_VERIFICATION.desc.unlocked': 'Verified email',
    'userManagement.userDetail.panes.badges.badge.FILLED_OUT_PROFILE.title': 'Certified Breaker',
    'userManagement.userDetail.panes.badges.badge.FILLED_OUT_PROFILE.desc.locked': 'Fill in full name, birthday, state, zip, and gender',
    'userManagement.userDetail.panes.badges.badge.FILLED_OUT_PROFILE.desc.unlocked': 'Filled in full name, birthday, state, zip, and gender',
    'userManagement.userDetail.panes.badges.badge.FOLLOWING_10_PEOPLE.title': 'Amigo',
    'userManagement.userDetail.panes.badges.badge.FOLLOWING_10_PEOPLE.desc.locked': 'Friend 10 people',
    'userManagement.userDetail.panes.badges.badge.FOLLOWING_10_PEOPLE.desc.unlocked': 'Friended 10 people',
    'userManagement.userDetail.panes.badges.badge.LOYALTY.title': 'Special Loyalty Badge',
    'userManagement.userDetail.panes.badges.badge.LOYALTY.desc.locked': 'Be a previous breaker',
    'userManagement.userDetail.panes.badges.badge.LOYALTY.desc.unlocked': 'Was a previous breaker',
    'userManagement.userDetail.panes.badges.badge.PERFECTED_25_TRIVIA.title': 'Einstein',
    'userManagement.userDetail.panes.badges.badge.PERFECTED_25_TRIVIA.desc.locked': 'Complete 25 Trivia breaks and get 100% correct',
    'userManagement.userDetail.panes.badges.badge.PERFECTED_25_TRIVIA.desc.unlocked': 'Completed 25 Trivia breaks and got 100% correct',
    'userManagement.userDetail.panes.badges.badge.PERFECTED_200_TRIVIA.title': 'Watson',
    'userManagement.userDetail.panes.badges.badge.PERFECTED_200_TRIVIA.desc.locked': 'Complete 200 Trivia breaks and get 100% correct',
    'userManagement.userDetail.panes.badges.badge.PERFECTED_200_TRIVIA.desc.unlocked': 'Completed 200 Trivia breaks and got 100% correct',
    'userManagement.userDetail.panes.badges.badge.REFERRAL_REG_5.title': 'Tipster',
    'userManagement.userDetail.panes.badges.badge.REFERRAL_REG_5.desc.locked': 'Get 5 new users to sign up',
    'userManagement.userDetail.panes.badges.badge.REFERRAL_REG_5.desc.unlocked': 'Got 5 new users to sign up',
    'userManagement.userDetail.panes.badges.badge.REFERRAL_REG_10.title': 'Newshound',
    'userManagement.userDetail.panes.badges.badge.REFERRAL_REG_10.desc.locked': 'Get 10 new users to sign up',
    'userManagement.userDetail.panes.badges.badge.REFERRAL_REG_10.desc.unlocked': 'Got 10 new users to sign up',
    'userManagement.userDetail.panes.badges.badge.REFERRAL_REG_25.title': 'Informer',
    'userManagement.userDetail.panes.badges.badge.REFERRAL_REG_25.desc.locked': 'Get 25 new users to sign up',
    'userManagement.userDetail.panes.badges.badge.REFERRAL_REG_25.desc.unlocked': 'Got 25 new users to sign up',
    'userManagement.userDetail.panes.badges.badge.RETENTION_30_DAYS.title': 'YoYo',
    'userManagement.userDetail.panes.badges.badge.RETENTION_30_DAYS.desc.locked': 'Come back to the site 30 days in a row',
    'userManagement.userDetail.panes.badges.badge.RETENTION_30_DAYS.desc.unlocked': 'Came back to the site 30 days in a row',
    'userManagement.userDetail.panes.badges.badge.RETENTION_90_DAYS.title': 'Boomerang',
    'userManagement.userDetail.panes.badges.badge.RETENTION_90_DAYS.desc.locked': 'Come back to the site 90 days in a row',
    'userManagement.userDetail.panes.badges.badge.RETENTION_90_DAYS.desc.unlocked': 'Came back to the site 90 days in a row',
    'userManagement.userDetail.panes.badges.badge.RETENTION_365_DAYS.title': 'Grand Slam',
    'userManagement.userDetail.panes.badges.badge.RETENTION_365_DAYS.desc.locked': 'Come back to the site 365 days in a row',
    'userManagement.userDetail.panes.badges.badge.RETENTION_365_DAYS.desc.unlocked': 'Came back to the site 365 days in a row',
    'userManagement.userDetail.panes.badges.badge.USERNAME_AND_PHOTO.title': 'Mona Lisa',
    'userManagement.userDetail.panes.badges.badge.USERNAME_AND_PHOTO.desc.locked': 'Uploaded a picture and told us a fun fact',
    'userManagement.userDetail.panes.badges.badge.USERNAME_AND_PHOTO.desc.unlocked': 'Picked a custom username, profile picture and filled in the \"About\" section in account settings.',

    // Hub
    'hubs.title': 'Hubs',
    'hubs.hub.title.humanity-hub': "Humanity Hub",

    // Humanology Hub Users
    'humanologyHubUsers.remove.confirm.header': "Remove Hub Users",
    'humanologyHubUsers.remove.confirm': "Are you sure you want to remove {count} users from this hub?",
    'humanologyHubUsers.remove.confirm.button': "Confirm",
    'humanologyHubUsers.remove.confirm.cancel': "Cancel",

    // Humanity (formerly known as Humanology) Hub Users
    'humanologyHubUsers.usersList.title': 'Humanity Hub Users',
    'humanologyHubUsers.usersList.header': 'Results',
    'humanologyHubUsers.usersList.columns': 'Show/Hide Columns',
    'humanologyHubUsers.usersList.export': 'Export CSV',
    'humanologyHubUsers.usersList.remove': 'Remove',
    'humanologyHubUsers.usersList.cell.multiple': 'Multiple',
    'humanologyHubUsers.usersList.column.select': 'Select',
    'humanologyHubUsers.usersList.column.photo': 'Photo',
    'humanologyHubUsers.usersList.column.id': 'User ID',
    'humanologyHubUsers.usersList.column.userId': 'User ID',
    'humanologyHubUsers.usersList.column.fullName': 'Full Name',
    'humanologyHubUsers.usersList.column.email': 'Email',
    'humanologyHubUsers.usersList.column.ageGroup': 'Age Group',
    'humanologyHubUsers.usersList.column.gender': 'Gender',
    'humanologyHubUsers.usersList.column.householdIncome': 'HHI',
    'humanologyHubUsers.usersList.column.employmentStatus': 'Employment Status',
    'humanologyHubUsers.usersList.column.maritalStatus': 'Marital Status',
    'humanologyHubUsers.usersList.column.homeType': 'Home Type',
    'humanologyHubUsers.usersList.column.householdMembers': 'Household Members',
    'humanologyHubUsers.usersList.column.state': 'State',
    'humanologyHubUsers.usersList.column.joinDate': 'Join Date',
    'humanologyHubUsers.usersList.column.joinDate.content': 'Joined Hub {joinDate} ({signUpBonus} points)',
    'humanologyHubUsers.usersList.column.facebook': 'Facebook',
    'humanologyHubUsers.usersList.column.instagram': 'Instagram',
    'humanologyHubUsers.usersList.column.pinterest': 'Pinterest',
    'humanologyHubUsers.usersList.column.snapchat': 'Snapchat',
    'humanologyHubUsers.usersList.column.twitter': 'Twitter',
    'humanologyHubUsers.usersList.column.travelDomesticLeisure': 'Domestic Leisure Travel',
    'humanologyHubUsers.usersList.column.travelDomesticWork': 'Domestic Work Travel',
    'humanologyHubUsers.usersList.column.travelInternationalLeisure': 'International Leisure Travel',
    'humanologyHubUsers.usersList.column.travelInternationalWork': 'International Work Travel',
    'humanologyHubUsers.usersList.column.haveFinancialAdvisor': 'Financial Advisor',
    'humanologyHubUsers.usersList.column.havePersonalTrainer': 'Personal Trainer',
    'humanologyHubUsers.usersList.column.memberHealthClub': 'Health Club',
    'humanologyHubUsers.usersList.column.memberBookOrWineClub': 'Book/Wine Club',
    'humanologyHubUsers.usersList.column.memberGameNight': 'Game Night',
    'humanologyHubUsers.usersList.column.memberFantasySports': 'Fantasy Sports',
    'humanologyHubUsers.usersList.column.educationProfessionalDevelopment': 'Professional Development Course',
    'humanologyHubUsers.usersList.column.educationPersonalDevelopment': 'Personal Development Course',
    'humanologyHubUsers.usersList.column.purchasedLifeInsurance': 'Life Insurance',
    'humanologyHubUsers.usersList.column.purchasedFinancialProduct': 'Financial Product',
    'humanologyHubUsers.usersList.column.neverExercise': 'Never Exercise',
    'humanologyHubUsers.usersList.column.rarelyExercise': 'Rarely Exercise',
    'humanologyHubUsers.usersList.column.averageExercise': 'Average Exercise',
    'humanologyHubUsers.usersList.column.frequentlyExercise': 'Frequently Exercise',
    'humanologyHubUsers.modal.visibleColumns.basicInfo.header': 'Basic Info',
    'humanologyHubUsers.modal.visibleColumns.demographics.header': 'Demographics',
    'humanologyHubUsers.modal.visibleColumns.socialPlatforms.header': 'Social Platforms',
    'humanologyHubUsers.modal.visibleColumns.recentActivities.header': 'Recent Activities',
    'humanologyHubUsers.modal.visibleColumns.healthAttitude.header': 'Health Attitude',
    'humanologyHubUsers.modal.export.header.error': 'Error Downloading Report',
    'humanologyHubUsers.modal.export.message.error': 'There was a problem creating the report you requested. Please try again.',
    'humanologyHubUsers.modal.export.header.success': 'Report Sent',
    'humanologyHubUsers.modal.export.message.success': 'A zip file containing the report you requested has been sent to your email.',

    'humanologyHubUsers.searchPanel.header': 'Filter',
    'humanologyHubUsers.searchPanel.submit': 'Update',
    'humanologyHubUsers.searchPanel.clear': 'Clear',

    'humanologyHubUsers.userDetail.action': 'Action',
    'humanologyHubUsers.userDetail.dateCompleted': 'Date Completed',
    'humanologyHubUsers.userDetail.pointsAwarded': 'Points Awarded',
    'humanologyHubUsers.userDetail.otherIncentive': 'Other Incentive',

    'humanology.survey.question.MARITAL_STATUS': 'Marital status',
    'humanology.survey.answer.MARRIED': 'Married',
    'humanology.survey.answer.SINGLE': 'Single',

    'humanology.survey.question.GENDER': 'Gender',
    'humanology.survey.answer.MALE': 'Male',
    'humanology.survey.answer.FEMALE': 'Female',

    'humanology.survey.question.AGE_RANGE': 'Age range',
    'humanology.survey.answer.AGE_RANGE_1': '18 – 24',
    'humanology.survey.answer.AGE_RANGE_2': '25 – 34',
    'humanology.survey.answer.AGE_RANGE_3': '35 – 44',
    'humanology.survey.answer.AGE_RANGE_4': '45 – 54',
    'humanology.survey.answer.AGE_RANGE_5': '55 – 64',
    'humanology.survey.answer.AGE_RANGE_6': '65+',

    // spelling error in key string is intentional (API data)
    'humanology.survey.question.EMPLOYMENT_STATUS': 'Employment status',

    'humanology.survey.answer.FULL_TIME': 'Full-time',
    'humanology.survey.answer.PART_TIME': 'Part-time',
    'humanology.survey.answer.HOMEMAKER': 'Homemaker',
    'humanology.survey.answer.OTHER': 'Other',

    'humanology.survey.question.HOUSEHOLD_INCOME_RANGE': 'Annual household income range',
    'humanology.survey.answer.INCOME_RANGE_1': '$0 – $50,000',
    'humanology.survey.answer.INCOME_RANGE_2': '$50,001 – $100,000',
    'humanology.survey.answer.INCOME_RANGE_3': '$100,001 - $150,000',
    'humanology.survey.answer.INCOME_RANGE_4': '$150,001 - $200,000',
    'humanology.survey.answer.INCOME_RANGE_5': 'Over $200,000',

    'humanology.survey.question.LIVING_SITUATION': 'Living situation',
    'humanology.survey.answer.OWN_HOME': 'Own home/condo',
    'humanology.survey.answer.RENT': 'Rent',

    'humanology.survey.question.HOUSEHOLD_SIZE': 'Members in household (including yourself)',
    'humanology.survey.answer.HOUSEHOLD_SIZE_1': '1',
    'humanology.survey.answer.HOUSEHOLD_SIZE_2': '2',
    'humanology.survey.answer.HOUSEHOLD_SIZE_3': '3',
    'humanology.survey.answer.HOUSEHOLD_SIZE_4': '4',
    'humanology.survey.answer.HOUSEHOLD_SIZE_5': '5',
    'humanology.survey.answer.HOUSEHOLD_SIZE_6': '6',
    'humanology.survey.answer.HOUSEHOLD_SIZE_7': '7+',

    'humanology.survey.question.HEALTH_ATTITUDE': 'Which of the following best describes your attitude and behaviors related to health and fitness?',
    'humanology.survey.answer.NEVER_EXERCISE': 'I don’t eat all that healthy and rarely find time to exercise.',
    'humanology.survey.answer.RARELY_EXERCISE': 'I try to watch what I eat and exercise a few times each month.',
    'humanology.survey.answer.AVERAGE_EXERCISE': 'My diet has a good balance of healthy foods and I exercise a couple of times each week.',
    'humanology.survey.answer.FREQUENTLY_EXERCISE': 'I eat very healthy and workout almost daily.',

    'humanology.survey.question.SOCIAL_PLATFORM_USAGE': 'Which social media platforms to you choose to use regularly? (Select all that apply)',
    'humanology.survey.answer.FACEBOOK': 'Facebook',
    'humanology.survey.answer.INSTAGRAM': 'Instagram',
    'humanology.survey.answer.PINTEREST': 'Pinterest',
    'humanology.survey.answer.SNAPCHAT': 'Snapchat',
    'humanology.survey.answer.TWITTER': 'Twitter',

    'humanology.survey.question.RECENT_ACTIVITIES': 'Which of the following activities have you done in the past 2 years? (Select all that apply)',
    'humanology.survey.answer.TRAVEL_DOMESTIC_LEISURE': 'Domestic leisure travel (overnight stay)',
    'humanology.survey.answer.TRAVEL_DOMESTIC_WORK': 'Domestic work travel (overnight stay)',
    'humanology.survey.answer.TRAVEL_INTERNATION_LESURE': 'International leisure travel',
    'humanology.survey.answer.TRAVEL_INTERNATIONAL_WORK': 'International work travel',
    'humanology.survey.answer.HAVE_FINANCIAL_ADVISOR': 'Have met with a financial advisor or planner in-person',
    'humanology.survey.answer.HAVE_PERSONAL_TRAINER': 'Have a personal trainer',
    'humanology.survey.answer.MEMBER_HEALTH_CLUB': 'Belong to a health club',
    'humanology.survey.answer.MEMBER_BOOK_OR_WINE_CLUB': 'Belong to a book or wine club',
    'humanology.survey.answer.MEMBER_GAME_NIGHT': 'Participate in game night with friends',
    'humanology.survey.answer.MEMBER_FANTASY_SPORTS': 'Participate in a fantasy sports league',
    'humanology.survey.answer.EDUCATION_PROFESSIONAL_DEVELOPMENT': 'Taken an educational course for professional development',
    'humanology.survey.answer.EDUCATION_PERSONAL_DEVELOPMENT': 'Taken an educational course for personal development',
    'humanology.survey.answer.PURCHASED_LIFE_INSURANCE': 'Have purchased some form of life insurance',
    'humanology.survey.answer.PURCHASED_FINANCIAL_PRODUCT': 'Have purchased some form of financial service product',

    'humanology.survey.filter.selectAll': 'Select all',
    'humanology.survey.filter.deselectAll': 'De-select all',
    'humanology.survey.filter.state': 'State',

    // Rewards Store
    'rewardsStore.table.mode.ReadOnly.header': '{site} Store {month} {year}',
    'rewardsStore.table.mode.Live.header': 'Edit Current Month - {site}',
    'rewardsStore.table.mode.Planning.header': '{site} Store Setup',
    'rewardsStore.table.mode.Planning.description': 'All changes are autosaved',

    'rewardsStore.table.link.dashboard': 'Back to Prizing Dashboard',
    'rewardsStore.table.button.add': 'Add',
    'rewardsStore.table.button.export': 'Export',
    'rewardsStore.table.column.title': 'Item',
    'rewardsStore.table.column.points': 'Points',
    'rewardsStore.table.column.quantity': 'Allocated',
    'rewardsStore.table.column.allocated': 'Allocated',
    'rewardsStore.table.column.inStock': 'In Stock',
    'rewardsStore.table.column.purchased': 'Purchased',
    'rewardsStore.table.column.price': 'Price',
    'rewardsStore.table.column.cost': 'Cost',
    'rewardsStore.table.overview.startDate': 'Start Date: {startDate}',
    'rewardsStore.table.overview.endDate': 'End Date: {endDate}',
    'rewardsStore.table.overview.budget': 'Budget',
    'rewardsStore.table.overview.allocated': 'Allocated',
    'rewardsStore.table.overview.purchased': 'Purchased',
    'rewardsStore.table.overview.available': 'Available',

    'rewardsStore.dashboard.page.header': 'Prizing Dashboard',
    'rewardsStore.dashboard.topRewards.header': 'Top Store Purchases for {site}',
    'rewardsStore.dashboard.storePicker.header': 'Store Details for {site}',
    'rewardsStore.dashboard.storePicker.dropdown.option': 'Store {year}',

    'rewardsStore.userLevel.coffee': 'Coffee',
    'rewardsStore.userLevel.lunch': 'Lunch',
    'rewardsStore.userLevel.weekend': 'Weekend',
    'rewardsStore.userLevel.spring': 'Spring',
    'rewardsStore.userLevel.summer': 'Summer',

    'rewardsStore.modal.createStore.header': '{site} Store {month} {year}',
    'rewardsStore.modal.createStore.message': 'Start Date: {startDate}',
    'rewardsStore.modal.createStore.label': 'Budget',
    'rewardsStore.modal.createStore.checkbox': 'Copy current month ({month})',
    'rewardsStore.modal.createStore.cancel': 'Cancel',
    'rewardsStore.modal.createStore.submit': 'Create',

    'rewardsStore.modal.retailerItem.header.create': 'Add Item - {site}',
    'rewardsStore.modal.retailerItem.header.update': 'Edit Item - {site}',
    'rewardsStore.modal.retailerItem.label.level': 'Level',
    'rewardsStore.modal.retailerItem.label.retailer': 'Retailer',
    'rewardsStore.modal.retailerItem.label.points': 'Points',
    'rewardsStore.modal.retailerItem.label.price': 'Price',
    'rewardsStore.modal.retailerItem.label.cost': 'Cost',
    'rewardsStore.modal.retailerItem.label.title': 'Reward Title',
    'rewardsStore.modal.retailerItem.label.type': 'Type',
    'rewardsStore.modal.retailerItem.label.description': 'Description',
    'rewardsStore.modal.retailerItem.label.legal': 'Legal',
    'rewardsStore.modal.retailerItem.label.image': 'Image',
    'rewardsStore.modal.retailerItem.button.cancel': 'Cancel',
    'rewardsStore.modal.retailerItem.button.submit': 'Confirm',
    'rewardsStore.modal.retailerItem.button.delete': 'Delete Item',
    'rewardsStore.modal.retailerItem.delete.confirm': 'Are you sure you want to delete this item?',
    'rewardsStore.modal.retailerItem.delete.yes': 'Yes',
    'rewardsStore.modal.retailerItem.delete.no': 'No',

    'rewardsStore.modal.export.header.error': 'Error Downloading Report',
    'rewardsStore.modal.export.message.error': 'There was a problem creating the report you requested. Please try again.',
    'rewardsStore.modal.export.header.success': 'Report Sent',
    'rewardsStore.modal.export.message.success': 'A zip file containing the report you requested has been sent to your email.',

    'rewardsStore.modal.purchaseInfo.table.column.userId': 'User ID',
    'rewardsStore.modal.purchaseInfo.table.column.fullName': 'Full Name',
    'rewardsStore.modal.purchaseInfo.table.column.email': 'Email',
    'rewardsStore.modal.purchaseInfo.table.column.ordered': 'Ordered',
    'rewardsStore.modal.purchaseInfo.button.resend': 'Resend',

    'rewardsStore.modal.storeStock.header.increase': 'Add to Store',
    'rewardsStore.modal.storeStock.header.decrease': 'Remove from Store',
    'rewardsStore.modal.storeStock.label.availableBudget': 'Available Budget',
    'rewardsStore.modal.storeStock.button.cancel': 'Cancel',
    'rewardsStore.modal.storeStock.button.submit': 'Confirm',

    'timezones.eastern': 'Eastern',
    'timezones.central': 'Central',
    'timezones.mountain': 'Mountain',
    'timezones.pacific': 'Pacific',
    'timezones.london': 'London',

    'userProfile.header1': 'User profile',
    'userProfile.header2': 'Edit user information',
    'userProfile.description': 'Edit your user information and change your password.',
    'userProfile.groupName': 'Your user group is: {groupName}',
    'userProfile.email': 'Email',
    'userProfile.firstName': 'First name',
    'userProfile.lastName': 'Last name',
    'userProfile.username': 'Username',
    'userProfile.submit': 'Save changes',
};



// WEBPACK FOOTER //
// ./public/i18n/en-US.js